import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const I18nCtx = createContext(null);
// LocalStorage key for cached overrides — read synchronously on first render
// so admin edits show up instantly on the next page load.
const OVERRIDES_LS_KEY = "supertmatik.i18n_overrides_v1";

const dict = {
  pt: {
    nav_home: "Início",
    nav_admin: "Admin",
    home_title: "SUPERTMATIK",
    home_subtitle: "Aprende a jogar, joga para aprender",
    rules_title: "Regulamento",
    train_start: "",
    level_or_tier: "Nível/Escalão",
    level_paren: "Nível",
    view_ranking_vs_time: "Ver ranking VS TEMPO",
    your_name: "O teu nome",
    your_nationality: "Nacionalidade",
    select_game: "Escolher jogo",
    play: "Jogar",
    login: "Entrar",
    username: "Username",
    password: "Password",
    logout: "Sair",
    rotate_device_title: "Roda o dispositivo",
    rotate_device_body: "Para jogar tens de virar o telemóvel/tablet para a posição horizontal (landscape).",
    rotate_to_portrait_title: "Roda o telemóvel",
    rotate_to_portrait_body: "Este ecrã só está disponível na posição vertical (portrait). Roda o telemóvel para continuar.",
    competition: "Competição",
    training: "VS TEMPO",
    rankings: "Classificações",
    ranking: "Posição",
    name: "Nome",
    school: "Escola",
    nationality: "Nacionalidade",
    best_time: "Melhor Tempo",
    attempts: "Tentativas",
    download_diploma: "Descarregar Diploma",
    diploma_indiv: "Diploma Individual",
    diploma_bulk: "Diplomas em Massa",
    school_register: "Inscrever Escola",
    email: "Email",
    submit: "Submeter",
    available_attempts: "Tens {n} tentativas disponíveis",
    exit_warning_title: "Se sair agora, esta partida conta como derrota.",
    exit_warning_subtitle: "Tens a certeza que queres sair?",
    start: "Começar",
    abandon: "Abandonar",
    correct: "Correto!",
    wrong: "Errado!",
    game_over: "Fim de Jogo",
    you_won: "Parabéns! Completaste SUPERT!",
    spin_roulette: "Girar Roleta",
    time: "Tempo",
    dashboard: "Dashboard",
    metrics: "Métricas",
    settings: "Definições Gerais",
    main_settings: "Definições principal",
    ads: "Publicidade",
    section_general: "Geral",
    section_games_content: "Conteúdo dos Jogos",
    section_users: "Utilizadores",
    section_appearance: "Rodapé",
    section_texts: "Textos",
    games: "Jogos",
    questions: "Perguntas",
    credentials: "Credenciais Competição",
    inscriptions: "Inscrições de Finalistas",
    payments: "Pagamentos",
    training_users: "Utilizadores VS TEMPO",
    competition_users: "Utilizadores Competição",
    comp_results_title: "Resultados Grande Final",
    comp_results_intro: "Classificação dos jogos de competição, por escalão/nível, jogados com credenciais.",
    elim_users: "Eliminatórias Escolares",
    elim_challenges: "Eliminatórias · Desafios",
    robots: "Robots",
    vsrobot_users: "Utilizadores VS Robot",
    vshuman_users: "Utilizadores VS Humano",
    demo_phrases: "DEMO — Aprender a Jogar",
    grande_final: "Grande Final",
    roulette: "Roleta",
    diplomas: "Diplomas",
    messages: "Mensagens",
    regulamento: "Regulamento",
    search_edit_texts: "Pesquisar & Editar",
    i18n_coverage: "Cobertura PT/EN/ES",
    db_migration: "Migração de Dados",
    pending_results: "Resultados Pendentes",
    themes: "Temas",
    home_buttons: "Botões da Home",
    test_zone: "Zona de Testes",
    intro: "Intro",
    footer: "Rodapé",
    results: "Resultados",
    create: "Criar",
    edit: "Editar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    save: "Guardar",
    cancel: "Cancelar",
    active: "Ativo",
    inactive: "Inativo",
    mode_normal: "Normal",
    mode_sem_sorte: "Sem Sorte",
    status_training: "VS TEMPO",
    status_competition: "Competição",
    status_both: "Ambos",
    status_eliminatorias: "Eliminatórias",
    upload_excel: "Importar Excel",
    export_excel: "Exportar Excel",
    generate: "Gerar",
    quantity: "Quantidade",
    students_count: "N.º alunos",
    level: "Nível",
    diploma_unavailable: "Diploma indisponível. Volta mais tarde!",
    diploma_not_yet_available: "Ainda não disponível",
    // Competition lobby
    lobby_welcome: "Bem-vindo, {username}!",
    lobby_confirm_hint: "Antes de jogar, confirma os teus dados e configura o avatar.",
    lobby_avatar_label: "Avatar",
    lobby_avatar_hint: "Clica para personalizar a tua cara virtual.",
    lobby_missing_prefix: "Falta preencher:",
    lobby_play_btn: "Jogar",
    lobby_logout_btn: "Terminar sessão",
    lobby_game_label: "Jogo",
    lobby_tier_or_level: "Escalão / Nível",
    lobby_level_only: "Nível",
    lobby_attempts_label: "Tentativas",
    lobby_previous_results: "Resultados anteriores",
    lobby_no_results: "Ainda não tens resultados.",
    lobby_win_label: "✓ Vitória",
    lobby_loss_label: "✗ Derrota",
    lobby_diploma_label: "Diploma",
    lobby_download_diploma: "Descarregar diploma",
    // Teacher confirmation modal
    teacher_modal_title: "Confirmação do professor",
    teacher_modal_body: "Ao introduzir a senha de professor confirmo que o Nome, Identificação da Escola e Nacionalidade do(a) aluno(a) estão corretos!",
    teacher_password_label: "Senha do professor",
    teacher_confirm_btn: "Confirmar e jogar",
    // Countdown before competition play
    countdown_go: "JÁ!",
    lobby_participation_ended: "Já terminou a sua participação. Não tem mais tentativas disponíveis.",
    continue_btn: "Continuar",
    select_placeholder: "Seleciona",
    insc_generate_hint_tiers: "Gera credenciais para os teus alunos por escalão",
    insc_generate_hint_levels: "Gera credenciais para os teus alunos por nível",
    insc_students_per_tier: "Alunos por escalão",
    insc_students_per_level: "Alunos por nível",
    insc_col_tier_or_level: "Nível/Escalão",
    insc_col_level: "Nível",
    insc_lvl_short: "Nv",
    insc_total: "Total",
    no_attempts: "Não tens tentativas disponíveis",
    login_error: "Credenciais inválidas",
    results: "Resultados",
    train_user_id: "ID VS TEMPO",
    welcome: "Bem-vindo",
    rank_vs_time_title: "Ranking - VS TEMPO",
    optional: "opcional",
    back_btn: "VOLTAR",
    exit_btn: "SAIR",
    audio_on: "SOM",
    audio_off: "SEM SOM",
    ready_title: "Estás preparado para começar?",
    lives_available: "Vidas disponíveis: {n}",
    sudden_death: "Morte Súbita",
    wrong_costs: "Cada resposta errada custa +{n}s ao tempo.",
    start_game: "INICIAR JOGO",
    demo_btn: "DEMO",
    // Result screens
    you_won_default: "VENCEU!",
    victory: "VITÓRIA!",
    defeat: "DERROTA!",
    congrats_name_bang: "Parabéns, {name}!",
    wrong_answer: "Resposta errada!",
    game_end: "Fim de jogo.",
    time_label: "Tempo:",
    attempts_left: "Tentativas restantes:",
    play_again: "Jogar de novo",
    try_again: "Tentar de novo",
    choose_other_game: "Escolher outro jogo",
    home_btn: "Página inicial",
    exit_lower: "Sair",
    loading_ranking: "A carregar ranking…",
    attempts_exhausted: "Tentativas esgotadas",
    thanks_participation: "Obrigado pela tua participação!",
    session_ends_10s: "A sessão termina automaticamente em 20 segundos…",
    thanks_participation: "Obrigado pela tua participação!",
    session_ends_in: "A sessão termina automaticamente em 20 segundos…",
    defeated_robot: "DERROTASTE O ROBOT!",
    robot_won: "O ROBOT VENCEU",
    beat_robot_duel: "Bateste o {robot} num duelo!",
    robot_finished_first: "O {robot} completou SUPERT primeiro.",
    you_won_points: "Ganhaste",
    you_lost_points: "Perdeste",
    points_unit: "pts",
    total_points: "Pontos acumulados:",
    share_my_rank: "Partilhar a minha posição #{n}",
    // Eliminatórias — Lobby (i18n batch 2026-02)
    play_btn: "Jogar",
    dismiss_btn: "Dispensar",
    attempt_one: "tentativa",
    attempt_many: "tentativas",
    // Ready modal (pre-game)
    ready_elim_header: "Eliminatória",
    ready_elim_header_wvl: "Eliminatória · Vitórias vs Derrotas",
    ready_elim_attempt_x_of_y: "Tentativa {current}/{total}",
    ready_elim_header_robot: "Eliminatória · Vencer Robot",
    ready_elim_target: "Alvo",
    ready_elim_used: "Usadas",
    ready_elim_left: "Restantes",
    ready_elim_wins: "Vitórias",
    ready_elim_losses: "Derrotas",
    ready_elim_games_left: "Jogos restantes",
    ready_competition_header: "Competição",
    ready_competition_used: "Já utilizadas",
    ready_competition_left: "Disponíveis",
    elim_lobby_almost_there: "Quase lá!",
    elim_lobby_complete_profile_hint: "Completa o teu perfil (nome, escola e nacionalidade) para apareceres corretamente na lista de finalistas.",
    elim_lobby_complete_now: "Completar agora",
    elim_lobby_eyebrow: "Eliminatórias",
    elim_lobby_greeting: "Olá, {name}!",
    elim_lobby_default_student: "aluno",
    elim_lobby_profile_btn: "Perfil",
    elim_lobby_logout_btn: "Sair",
    elim_lobby_load_error: "Não foi possível carregar o lobby.",
    elim_lobby_combo_not_found: "Não encontrei essa combinação de jogo e escalão.",
    elim_lobby_start_error: "Não foi possível iniciar.",
    elim_lobby_no_results_title: "Sem resultados para a tua pesquisa.",
    elim_lobby_no_results_hint: "Tenta limpar os filtros ou procurar por outro termo.",
    elim_share_prepare_error: "Não foi possível preparar a partilha.",
    elim_share_download_diploma_title: "Descarregar diploma em PDF",
    elim_share_diploma_btn: "Diploma",
    elim_share_social_title: "Partilhar nas redes sociais",
    elim_share_share_btn: "Partilhar",
    elim_share_dialog_title: "Partilhar diploma",
    elim_share_preview_alt: "Pré-visualização do diploma",
    elim_share_tag_instagram: "Marcar @supertmatik no Instagram",
    elim_share_all_ready: "Tudo pronto! Agora:",
    elim_share_step1: "A <strong>imagem</strong> do diploma foi descarregada para o teu dispositivo.",
    elim_share_step2: "A <strong>legenda</strong> (com <code class='bg-white px-1.5 py-0.5 rounded text-pink-700 font-bold'>@supertmatik</code> + #hashtags) foi copiada.",
    elim_share_step3: "Abre o <strong>Instagram</strong>, cria uma publicação ou story, escolhe a imagem descarregada.",
    elim_share_step4: "<strong>Cola a legenda</strong> no campo de texto — vai ficar com @supertmatik clicável.",
    elim_share_step5: "Publica! 🎉",
    elim_share_copy_again: "Voltar a copiar a legenda",
    elim_share_view_caption: "Ver legenda",
    elim_share_info: "<strong>Instagram:</strong> usa o botão rosa em cima — copiamos a legenda com <code class='bg-slate-100 px-1 rounded'>@supertmatik</code> e descarregamos a imagem. <strong>WhatsApp/Twitter/Facebook:</strong> partilha o link diretamente.",
    elim_share_download_img: "Descarregar imagem",
    elim_share_copy_img: "Copiar imagem",
    elim_share_copy_caption_btn: "Copiar legenda",
    elim_share_img_downloaded: "Imagem descarregada — agora podes anexá-la nas redes!",
    elim_share_img_copied: "Imagem copiada — cola onde quiseres!",
    elim_share_img_copy_fail: "O teu browser não permite copiar imagens. Usa o botão Descarregar.",
    elim_share_clipboard_fail: "O teu browser não permite copiar para a área de transferência.",
    elim_share_caption_copied: "Legenda copiada!",
    elim_share_copy_fail: "Não foi possível copiar.",
    elim_share_caption_copied_again: "Legenda copiada novamente!",
    elim_share_copy_fail_manual: "Não foi possível copiar. Copia manualmente abaixo.",
    elim_share_finalist_text: "Sou FINALISTA SUPERTMATIK em {game}! 🏆 #SUPERTMATIK",
    elim_share_instagram_caption: "Sou FINALISTA SUPERTMATIK em {game}! 🏆\n\nObrigado @supertmatik 💜\n#SUPERTMATIK #supertmatik #campeonatos_escolares",
    elim_share_diploma_downloaded: "Diploma descarregado!",
    elim_share_diploma_download_fail: "Não foi possível descarregar o diploma.",
    elim_share_shared: "Partilhado!",
    elim_share_webshare_title: "Diploma SUPERTMATIK · {game}",
    elim_profile_title: "O meu perfil",
    elim_profile_tab_avatar: "Avatar",
    elim_profile_tab_profile: "Perfil",
    elim_profile_tab_password: "Password",
    elim_profile_avatar_updated: "Avatar atualizado!",
    elim_profile_avatar_save_fail: "Não foi possível guardar o avatar.",
    elim_profile_avatar_hint: "Personaliza o teu avatar — cabelo, olhos, roupa, cor… vai aparecer ao lado do teu nome na lista de finalistas e no diploma.",
    elim_profile_edit_avatar: "Editar avatar",
    elim_profile_create_avatar: "Criar avatar",
    elim_profile_updated: "Perfil atualizado!",
    elim_profile_save_fail: "Não foi possível guardar.",
    elim_profile_name_label: "Nome completo",
    elim_profile_name_ph: "Ana Silva",
    elim_profile_school_label: "Escola",
    elim_profile_school_ph: "EB 2,3 Exemplo",
    elim_profile_nationality_label: "Nacionalidade",
    elim_profile_saving: "A guardar…",
    elim_profile_save_btn: "Guardar alterações",
    elim_profile_pwd_min: "A nova password deve ter pelo menos 6 caracteres.",
    elim_profile_pwd_mismatch: "As passwords não coincidem.",
    elim_profile_pwd_updated: "Password atualizada.",
    elim_profile_pwd_update_fail: "Não foi possível atualizar.",
    elim_profile_cur_pwd_label: "Password atual",
    elim_profile_new_pwd_label: "Nova password",
    elim_profile_confirm_label: "Confirmar",
    elim_profile_new_pwd_ph: "6+ caracteres",
    elim_profile_confirm_ph: "repete a nova password",
    elim_profile_pwd_saving: "A atualizar…",
    elim_profile_pwd_save_btn: "Atualizar password",
    elim_reset_token_missing: "Token em falta no link.",
    elim_reset_pwd_min: "A password deve ter pelo menos 6 caracteres.",
    elim_reset_pwd_updated: "Password atualizada!",
    elim_reset_fail: "Não foi possível atualizar a password.",
    elim_reset_title: "Nova password",
    elim_reset_subtitle: "Define uma nova password para a tua conta de Eliminatórias.",
    elim_reset_all_good: "Tudo certo!",
    elim_reset_done_body: "A tua password foi atualizada. Já podes entrar com as novas credenciais.",
    elim_reset_goto_login: "Ir para o login",
    elim_reset_no_token_body: "Token em falta. Pede novamente o link de recuperação.",
    elim_reset_back: "← Voltar",
    elim_reset_confirm_ph: "repete a password",
    elim_lobby_you_are_finalist: "És FINALISTA!",
    elim_lobby_category_one: "categoria",
    elim_lobby_category_many: "categorias",
    elim_lobby_finalist_categories: "Apurado em {n} {plural}. Descarrega o teu diploma na secção correspondente abaixo e aguarda a convocatória para a Grande Final.",
    elim_lobby_account: "Conta",
    elim_lobby_no_school: "sem escola",
    elim_lobby_no_country: "sem país",
    elim_lobby_challenges_available: "Desafios disponíveis",
    elim_lobby_complete_all_to_qualify: "Completa <strong>todas</strong> as eliminatórias de um jogo para te apurares à Grande Final.",
    elim_lobby_continue_where: "Continuar onde paraste",
    elim_lobby_want_to_continue: "Queres continuar a tentativa de",
    elim_lobby_empty: "Ainda não há eliminatórias ativas. Volta em breve!",
    elim_lobby_search_placeholder: "Procurar jogo ou escalão…",
    elim_lobby_search_clear_aria: "Limpar pesquisa",
    elim_lobby_filter_all: "Todos",
    elim_lobby_filter_in_progress: "Em curso",
    elim_lobby_filter_finalist: "Finalista",
    elim_lobby_filter_not_started: "Por começar",
    elim_lobby_game_label: "Jogo",
    elim_lobby_tier_label: "Escalão",
    elim_lobby_passed_count: "passadas",
    elim_lobby_finalist_badge: "Finalista",
    elim_lobby_my_active_games: "Os meus jogos em curso",
    elim_lobby_explore_others: "Explorar outros jogos",
    elim_lobby_pick_a_game: "Escolhe um jogo para começar",
    elim_lobby_game_available_one: "jogo disponível",
    elim_lobby_game_available_many: "jogos disponíveis",
    elim_lobby_x_games_available: "Há <b>{n} {plural}</b> com vários escalões. Seleciona abaixo para abrires diretamente o que te interessa.",
    elim_lobby_pick_game_option: "— Escolhe um jogo —",
    elim_lobby_pick_tier_option: "— Escolhe um escalão —",
    elim_lobby_no_tiers: "— Sem escalões definidos —",
    elim_lobby_open_btn: "Abrir",
    elim_lobby_back_home: "← Voltar à página inicial",
    elim_lobby_tier_done_suffix: "já concluído",
    elim_lobby_tier_failed_suffix: "tentativas esgotadas",
    // Eliminatória card
    elim_card_label: "Eliminatória",
    elim_card_mode_vs_robot: "VS ROBOT",
    elim_card_mode_wvl: "VITÓRIAS vs DERROTAS",
    elim_card_mode_avg: "TEMPO MÉDIO",
    elim_card_mental: "Força mental",
    elim_card_wins: "Vitórias",
    elim_card_losses: "Derrotas",
    elim_card_attempts: "Tentativas",
    elim_card_games_avg: "Jogos · Média",
    elim_card_target: "Alvo",
    elim_card_attempt_failed: "Tentativa falhou · começa uma nova ({left} restantes)",
    elim_card_beat_robot: "Vence o robot",
    elim_card_wvl_summary: "{wins} vit. em {total} jogos",
    elim_card_avg_summary: "média ≤ {target}s · {games}×{attempts}",
    elim_card_target_summary: "alvo {seconds}s",
    elim_card_objective_label: "Objetivo",
    elim_card_start_game: "Iniciar jogo",
    elim_card_starting: "A iniciar…",
    elim_card_attempts_total_label: "Tentativas",
    elim_card_attempts_avail_label: "Tentativas disponíveis",
    elim_hist_title: "Resumo das tentativas",
    elim_hist_attempt: "Tentativa {n}",
    elim_hist_robot_won: "Venceste o robô na tentativa nº {n}!",
    elim_hist_robot_not_yet: "Ainda não venceste o robô!",
    elim_hist_win_abbr: "V",
    elim_hist_loss_abbr: "D",
    elim_obj_wvl: "Vencer {wins} jogos em {total}",
    elim_obj_robot: "Vencer o robô {name}",
    elim_obj_target: "Conseguir uma vitória em {seconds}s",
    elim_obj_avg: "Tempo médio ≤ {target}s em {games} jogos",
    elim_card_status_passed: "Concluída",
    elim_card_status_locked: "Bloqueada — completa a anterior",
    elim_card_status_impossible: "Impossível passar",
    elim_card_status_exhausted: "Tentativas esgotadas",
    elim_card_continue_attempt: "Continuar tentativa (jogo {game}/{total})",
    elim_card_new_attempt: "Nova tentativa ({left} restantes)",
    elim_card_remaining_one: "restante",
    elim_card_remaining_many: "restantes",
    share_title: "Partilhar posição #{rank}",
    share_generating: "A gerar imagem…",
    share_image_alt: "Cartão de posição",
    share_hint_html: "<strong>Instagram:</strong> descarrega a imagem e publica do telemóvel. <strong>WhatsApp/Twitter/Facebook:</strong> partilha o link diretamente.",
    share_btn_download: "Descarregar",
    share_btn_copy_image: "Copiar imagem",
    share_btn_copy_caption: "Copiar legenda",
    share_btn_native: "Partilhar (sistema)",
    share_error_generate: "Não foi possível gerar a imagem.",
    share_toast_downloaded: "Imagem descarregada — partilha onde quiseres!",
    share_toast_copied_image: "Imagem copiada!",
    share_toast_copy_image_unsupported: "O teu browser não permite copiar imagens. Usa o botão Descarregar.",
    share_toast_copy_unsupported: "Browser não suporta cópia.",
    share_toast_copied_caption: "Legenda copiada!",
    share_toast_copy_failed: "Não foi possível copiar.",
    share_robot_fallback: "o robot",
    share_caption: "Acabei de derrotar o {robot} no SUPERTMATIK VS ROBOT e estou no #{rank} de {total}! 🤖⚔️ #supertmatik",
    another_duel: "Outro duelo",
    rematch: "Desforra com {name}",
    rematch_short: "Desforra",
    play_again_with: "Jogar de novo com {name}?",
    opponent_default: "adversário",
    // Mode names (rendered as page titles / combobox labels / share captions).
    mode_vs_time: "VS TEMPO",
    mode_vs_robot: "VS ROBOT",
    mode_vs_human: "VS HUMANO",
    duel_one: "duelo",
    duel_many: "duelos",
    common_loading: "A carregar…",
    preparing_game: "A preparar o teu jogo…",
    preparing_game_hint: "Só um instante, já vais começar!",
    common_exit: "Sair",
    ranking_page_title: "Ranking",
    ranking_type_label: "Tipo de ranking",
    choose_other_robot: "Escolher outro robot",
    back_to_eliminations: "Voltar às eliminatórias",
    dont_give_up: "Não desistas — escolhe outro robot ou tenta outro nível!",
    try_again_one_attempt: "Ainda tens 1 tentativa disponível.",
    try_again_many_attempts: "Ainda tens {left} tentativas disponíveis.",
    attempts_left_one: "Ainda tens 1 tentativa disponível nesta eliminatória.",
    attempts_left_many: "Ainda tens {left} tentativas disponíveis nesta eliminatória.",
    no_attempts_left_sentence: "Já não tens tentativas — a eliminatória terminou.",
    checking_attempts: "A confirmar tentativas restantes…",
    new_attempt: "Nova tentativa",
    calculating_ranking: "A calcular ranking…",
    won_duel: "VENCESTE O DUELO!",
    lost_duel: "PERDESTE O DUELO",
    duel_discarded: "DUELO DESCARTADO",
    opponent_disconnected: "O adversário desligou — o resultado não foi guardado.",
    tie_no_record: "Empate técnico: não conta como vitória nem como derrota.",
    lost_connection_15s: "Perdeste a ligação durante mais de 15s.",
    tie_not_saved: "Empate técnico: o resultado não foi guardado.",
    beat_in_realtime: "Bateste {robot} em tempo real!",
    back_to_lobby: "Voltar ao início",
    want_more_lobby: "Quer mais? Encontra outro adversário no lobby.",
    try_again_lobby: "Volta ao lobby e tenta outra vez!",
    you_are_finalist: "ÉS FINALISTA!",
    knockout_passed: "ELIMINATÓRIA SUPERADA!",
    almost: "QUASE!",
    qualified_for_final: "Apuraste-te para a Grande Final 🎉",
    target_label: "alvo",
    won_but_not_target: "Venceste o jogo mas não dentro do tempo-alvo.",
    // Wins-vs-Losses (vitórias vs derrotas) mode messages
    wvl_won_this_game: "VITÓRIA!",
    wvl_lost_this_game: "DERROTA",
    wvl_wins: "Vitórias",
    wvl_losses: "Derrotas",
    wvl_keep_going: "Ainda tens {left} jogos e precisas de mais {need} vitórias para passar.",
    wvl_keep_going_1g_nv: "Ainda tens {left} jogo e precisas de mais {need} vitórias para passar.",
    wvl_keep_going_ng_1v: "Ainda tens {left} jogos e precisas de mais {need} vitória para passar.",
    wvl_keep_going_1g_1v: "Ainda tens {left} jogo e precisas de mais {need} vitória para passar.",
    wvl_impossible: "Já não é possível atingir as vitórias necessárias nesta tentativa.",
    wvl_attempt_failed_title: "Tentativa falhada",
    wvl_attempt_failed_hint: "Esta tentativa foi dada como perdida — ainda tens {left} tentativa{plural} para passar a eliminatória.",
    wvl_no_attempts_left: "Já não tens tentativas — eliminatória falhada.",
    wvl_start_new_attempt: "Começar nova tentativa",
    wvl_play_next: "Jogar próximo",
    // AVG-TIME mode (2026-02) — average time across N attempts.
    avg_time_impossible_title: "Já não é possível :(",
    avg_time_progress_title: "Boa! Jogo terminado",
    avg_time_attempts: "Tentativas",
    avg_time_current: "Média atual",
    avg_time_target: "Média alvo",
    avg_time_next_hint: "Faz o próximo em ≤ {seconds}s para manteres o alvo alcançável.",
    avg_time_terminated_hint: "Mesmo com 0 segundos nos restantes jogos, não consegues bater a média alvo. Eliminatória falhada.",
    avg_time_play_next: "Jogar próximo",
    avg_time_aborted_title: "Falhaste este jogo",
    avg_time_aborted_hint: "No modo Tempo Médio, cada jogo tem de ser vencido. A eliminatória terminou.",
    // v2 (2026-02): multi-attempt semantics
    avg_time_games_col: "Jogos",
    avg_time_attempts_left_col: "Tent. restantes",
    avg_time_attempt_x_of_y: "Tentativa {current} de {total}",
    avg_time_next_game_hint: "Faz o próximo em ≤ {seconds}s para te manteres dentro da média alvo!",
    avg_time_play_next_in_attempt: "Jogar próximo ({current}/{total})",
    avg_time_start_new_attempt: "Começar nova tentativa",
    avg_time_attempt_lost_title: "Perdeste esta tentativa",
    avg_time_attempt_lost_hint: "Perdeste um jogo — esta tentativa falhou (todos os jogos têm de ser vencidos).",
    avg_time_attempt_slow_title: "Média demasiado alta",
    avg_time_attempt_slow_hint: "Completaste os jogos, mas a média ficou acima do alvo. Esta tentativa falhou.",
    avg_time_attempt_unreachable_title: "Já não dá para chegar à média",
    avg_time_attempt_unreachable_hint: "Mesmo que os próximos jogos fossem a 0 segundos, a média ficaria acima do alvo. Esta tentativa foi dada como perdida.",
    avg_time_attempts_left_hint: "Ainda tens {left} tentativa{plural} para conseguir.",
    avg_time_no_attempts_left: "Já não tens tentativas — eliminatória falhada.",
    attempts_remaining_this_elim: "Tentativas restantes nesta eliminatória:",
    did_not_pass: "NÃO PASSASTE",
    failed_attempt: "Tentativa falhada",
    each_new_attempt_costs: "Cada nova tentativa consome 1 das tuas tentativas disponíveis.",
    knockout_label: "Eliminatória",
    passed_uppercase: "PASSASTE!",
    knockout_now_complete: "Esta eliminatória está agora concluída.",
    elim_info_title: "Dados do aluno",
    elim_info_student: "Aluno",
    elim_info_school: "Escola",
    elim_info_game: "Jogo",
    elim_info_level: "Escalão / Nível",
    // Avatar builder
    avatar_customize: "Personaliza o teu avatar",
    random: "Aleatório",
    male: "Masculino",
    female: "Feminino",
    bg_color: "Cor de fundo",
    save_btn: "Guardar",
    ava_hair: "Cabelo",
    ava_eyes: "Olhos",
    ava_eyebrows: "Sobrancelhas",
    ava_mouth: "Boca",
    ava_glasses: "Óculos",
    ava_clothes: "Roupa",
    ava_skin: "Pele",
    ava_haircolor: "Cor cabelo",
    ava_clothecolor: "Cor roupa",
    ava_beard: "Barba",
    ava_beardcolor: "Cor barba",
    vsr_hero_title_left: "VS",
    vsr_hero_title_right: "",
    vsr_hero_desc: "Cada robot é avaliado em três parâmetros: rapidez de resposta, percentagem de respostas corretas e força mental. Vence um robot e ganha pontos para o ranking — tantos quanto o dobro da sua força mental! Mas cuidado! Se perderes, serão descontados pontos correspondentes a metade da força mental do robô que te derrotou.",
    vsr_step_name: "Como te chamas?",
    train_name_required: "Indica o teu nome para começar.",
    train_nationality_required: "Escolhe a tua nacionalidade.",
    train_game_required: "Escolhe um jogo.",
    vsr_load_failed: "Não foi possível carregar.",
    vsr_pick_robot: "Escolhe um robot adversário.",
    vsr_missing_fields: "Faltam {n} campos: {list}",
    vsh_invite_declined: "Convite recusado.",
    vsh_private_code_ready: "Código pronto: {code}",
    vsh_name_required: "Indica o teu nome.",
    vsh_invite_sent: "Convite enviado a {name}",
    vsh_invite_expired: "Sem resposta — convite expirou.",
    vsh_invite_timeout_auto_decline: "Tempo esgotado — convite recusado automaticamente.",
    vsh_rematch_waiting: "A aguardar {name} para a desforra…",
    vsh_rematch_unavailable: "{name} não voltou ao lobby — sem desforra desta vez.",
    vsh_rematch_offline: "Adversário indisponível — desforra cancelada.",
    vsh_rematch_declined: "{name} recusou a desforra.",
    vsh_rematch_prompt: "Desforra?",
    vsh_rematch_prompt_sub: "{name} quer uma revanche imediata!",
    vsh_rematch_accept: "Aceitar Desforra",
    vsh_rematch_decline: "Deixar assim",
    vsh_playagain_prompt: "Novo jogo?",
    vsh_playagain_prompt_sub: "{name} quer jogar de novo contigo!",
    vsh_playagain_accept: "Aceitar",
    vsh_playagain_decline: "Agora não",
    vsh_copied: "Copiado!",
    vsh_error_generic: "Erro",
    vsh_fill_field_before_room: "Preenche o {field} antes de criar a sala.",
    vsh_fill_missing_fields: "Preenche os campos em falta: {list}.",
    vsh_field_name: "nome",
    vsh_field_game: "jogo",
    vsh_field_code: "código de 4 dígitos",
    vsh_pick_code: "Indica um código de 4 dígitos.",
    // VS HUMANO — lobby / UI copy (2026-02)
    vsh_connecting: "a ligar…",
    vsh_page_intro: "Joga um duelo em tempo real contra outro humano. Escolhe o teu jogo e o teu nível/escalão — só verás online quem escolheu o mesmo jogo, mas cada um joga no seu próprio nível.",
    vsh_invite_expire_tip: "Tempo até o convite expirar",
    vsh_step_choose_game: "Escolhe o jogo",
    vsh_step_choose_level: "Escolhe o nível",
    vsh_step_who_online: "Quem está online?",
    vsh_hint_pick_game_first: "Escolhe primeiro um jogo",
    vsh_hint_pick_name: "Indica o teu nome",
    vsh_level_or_tier: "Nível / Escalão",
    vsh_level_label: "Nível",
    vsh_searching: "À procura de adversário…",
    vsh_searching_sub_html: "Aparecem aqui outros jogadores online que <b>escolheram este mesmo jogo</b>. Cada um joga no seu próprio nível/escalão — o primeiro a completar SUPERT vence.",
    vsh_challenge: "Desafiar",
    vsh_waiting_short: "A aguardar…",
    vsh_private_title: "DUELO PRIVADO",
    vsh_private_host_title: "Criar código (host)",
    vsh_private_generate: "Gerar código",
    vsh_private_enter_title: "Introduzir código",
    vsh_private_enter_btn: "Entrar",
    vsh_private_hint: "Combinas o código com um amigo. O host define o jogo e nível.",
    vsh_back_home: "← Voltar à página inicial",
    vsh_invite_title: "Convite de duelo!",
    vsh_invite_sub: "<b>{name}</b> quer desafiar-te.",
    vsh_invite_countdown_prefix: "Decisão automática em",
    vsh_accept: "Aceitar",
    vsh_reject: "Recusar",
    vsr_step_game: "Escolhe o jogo",
    vsr_step_level: "Escolhe o nível",
    vsr_step_robot: "Escolhe o robot adversário",
    vsr_pick_game_first: "Escolhe primeiro um jogo",
    vsr_loading: "A carregar…",
    vsr_no_games: "Sem jogos disponíveis.",
    vsr_no_robots: "Ainda não há robots configurados para este jogo. Pede ao administrador para criar um.",
    vsr_start_duel: "Iniciar duelo",
    back_to_home: "Voltar à página inicial",
    levels_label: "Níveis",
    tiers_label: "Escalões",
    yes: "Sim",
    no: "Não",
    lives_lost_title: "Perdeste uma vida!",
    lives_used: "Vidas gastas",
    lives_remaining: "Restantes",
    penalty_applied: "Penalização aplicada",
    continue_btn: "CONTINUAR",
    logout: "Terminar sessão",
    logout_confirm: "Tem a certeza de que pretende terminar a sessão?",
    logout_warn_loss: "Esta partida contará como uma derrota!",
    welcome_back: "Olá",
    edit_btn: "Editar",
    rank_competition_title: "Ranking - Competição",
    col_game: "JOGO",
    col_level: "NÍVEL",
    col_level_or_tier: "NÍVEL/ESCALÃO",
    col_name: "NOME",
    col_school: "ESCOLA",
    col_best_time: "MELHOR TEMPO",
    col_share: "PARTILHAR",
    all_levels: "Todos os níveis",
    all_tiers: "Todos os escalões",
    // ── Eliminatórias landing page ────────────────────────────────────
    elim_landing_eyebrow: "Eliminatórias SUPERTMATIK",
    elim_landing_title_prefix: "Rumo à",
    elim_landing_title_highlight: "Grande Final",
    elim_landing_title_suffix: "!",
    elim_landing_subtitle: "Cria a tua conta de aluno, supera as eliminatórias do teu jogo preferido e habilita-te a um lugar na Grande Final.",
    elim_landing_how_it_works: "Como funciona",
    elim_landing_step_1: "Cria a tua conta — basta um username, email e password.",
    elim_landing_step_2: "Completa o teu perfil com nome, escola e nacionalidade.",
    elim_landing_step_3: "Escolhe uma eliminatória disponível e supera o desafio.",
    elim_landing_step_4: "Conclui todas as eliminatórias do mesmo jogo e qualifica-te para a Grande Final!",
    elim_landing_important_label: "Importante:",
    elim_landing_important_body: "a tua conta de Eliminatórias é independente das credenciais de competição/treino. Cada aluno tem a sua.",
    elim_landing_tab_login: "Entrar",
    elim_landing_tab_register: "Criar conta",
    elim_landing_tab_forgot: "Recuperar",
    elim_landing_back_home: "← Voltar à página inicial",
    elim_login_username_label: "Username ou email",
    elim_login_username_ph: "ex: ana_silva ou ana@escola.pt",
    elim_login_password_ph: "••••••••",
    elim_login_submit: "Entrar",
    elim_login_submitting: "A entrar…",
    elim_reg_username_label: "Username*",
    elim_reg_username_ph: "ana_silva",
    elim_reg_email_label: "Email*",
    elim_reg_email_ph: "ana@escola.pt",
    elim_reg_password_label: "Password*",
    elim_reg_password_ph: "6+ caracteres",
    elim_reg_confirm_label: "Confirmar*",
    elim_reg_confirm_ph: "repete a password",
    elim_reg_profile_hint: "Perfil (opcional — podes preencher depois)",
    elim_reg_name_label: "Nome completo",
    elim_reg_name_ph: "Ana Silva",
    elim_reg_school_label: "Escola",
    elim_reg_school_ph: "EB 2,3 Exemplo",
    elim_reg_nationality_label: "Nacionalidade",
    elim_reg_submit: "Criar conta e entrar",
    elim_reg_submitting: "A criar conta…",
    elim_reg_has_account: "Já tens conta?",
    elim_reg_go_login: "Entra aqui",
    elim_forgot_hint: "Indica o email associado à tua conta de Eliminatórias e enviar-te-emos um link para definires uma nova password.",
    elim_forgot_email_label: "Email",
    elim_forgot_submit: "Enviar link de recuperação",
    elim_forgot_submitting: "A enviar…",
    elim_forgot_back: "← Voltar ao login",
    elim_forgot_request_sent: "Pedido enviado!",
    elim_forgot_request_body: "Se o email existir na nossa base de dados, recebeste um link para definir uma nova password (válido por 1 hora).",
    elim_forgot_test_mode_label: "Modo de teste (email MOCKED):",
    elim_forgot_test_mode_hint: "usa este link para continuar.",
    elim_forgot_open_reset: "Abrir link de reset",
    // Common error/toast strings used across forms
    err_fill_all: "Preenche todos os campos.",
    err_login_failed: "Não foi possível entrar.",
    err_register_failed: "Não foi possível criar a conta.",
    err_required_fields: "Username, email e password são obrigatórios.",
    err_password_too_short: "A password deve ter pelo menos 6 caracteres.",
    err_passwords_no_match: "As passwords não coincidem.",
    err_forgot_failed: "Não foi possível processar o pedido.",
    ok_welcome_named: "Bem-vindo, {name}!",
    ok_account_created: "Conta criada com sucesso!",
  },
  en: {
    nav_home: "Home",
    nav_admin: "Admin",
    home_title: "SUPERTMATIK",
    home_subtitle: "Learn to play, play to learn",
    rules_title: "Rules",
    train_start: "",
    level_or_tier: "Level/Category",
    level_paren: "Level",
    view_ranking_vs_time: "View ranking VS Time",
    your_name: "Your name",
    your_nationality: "Nationality",
    select_game: "Choose a game",
    play: "Play",
    login: "Log in",
    username: "Username",
    password: "Password",
    logout: "Log out",
    rotate_device_title: "Rotate your device",
    rotate_device_body: "To play, please rotate your phone/tablet to landscape orientation.",
    rotate_to_portrait_title: "Rotate your phone",
    rotate_to_portrait_body: "This screen is only available in portrait orientation. Please rotate your phone back to continue.",
    competition: "Competition",
    training: "VS Time",
    rankings: "Rankings",
    ranking: "Rank",
    name: "Name",
    school: "School",
    nationality: "Nationality",
    best_time: "Best Time",
    attempts: "Attempts",
    download_diploma: "Download Diploma",
    diploma_indiv: "Individual Diploma",
    diploma_bulk: "Bulk Diplomas",
    school_register: "Register School",
    email: "Email",
    submit: "Submit",
    available_attempts: "You have {n} attempts available",
    exit_warning_title: "If you leave now, this match will count as a loss.",
    exit_warning_subtitle: "Are you sure you want to leave?",
    start: "Start",
    abandon: "Abandon",
    correct: "Correct!",
    wrong: "Wrong!",
    game_over: "Game Over",
    you_won: "Congratulations! You completed SUPERT!",
    spin_roulette: "Spin Roulette",
    time: "Time",
    dashboard: "Dashboard",
    metrics: "Metrics",
    settings: "General Settings",
    main_settings: "Main Settings",
    ads: "Advertising",
    section_general: "General",
    section_games_content: "Game Content",
    section_users: "Users",
    section_appearance: "Footer",
    section_texts: "Texts",
    games: "Games",
    questions: "Questions",
    credentials: "Competition Credentials",
    inscriptions: "Finalist Enrolments",
    payments: "Payments",
    training_users: "Training Users",
    competition_users: "Competition Users",
    comp_results_title: "Grand Final Results",
    comp_results_intro: "Ranking of competition games, by tier/level, played with credentials.",
    elim_users: "Knockout Students",
    elim_challenges: "Knockout Challenges",
    robots: "Robots",
    vsrobot_users: "VS Robot Users",
    vshuman_users: "VS Human Users",
    demo_phrases: "DEMO — Learn to Play",
    grande_final: "Grand Final",
    roulette: "Roulette",
    diplomas: "Diplomas",
    messages: "Messages",
    regulamento: "Rules",
    search_edit_texts: "Search & Edit",
    i18n_coverage: "PT/EN/ES Coverage",
    db_migration: "Data Migration",
    pending_results: "Pending Results",
    themes: "Themes",
    home_buttons: "Home Buttons",
    footer: "Footer",
    test_zone: "Test Zone",
    intro: "Intro",
    results: "Results",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    duplicate: "Duplicate",
    save: "Save",
    cancel: "Cancel",
    active: "Active",
    inactive: "Inactive",
    mode_normal: "Normal",
    mode_sem_sorte: "No Luck",
    status_training: "VS Time",
    status_competition: "Competition",
    status_both: "Both",
    status_eliminatorias: "Knockouts",
    upload_excel: "Import Excel",
    export_excel: "Export Excel",
    generate: "Generate",
    quantity: "Quantity",
    students_count: "No. of students",
    level: "Level",
    diploma_unavailable: "Diploma unavailable. Come back later!",
    diploma_not_yet_available: "Not yet available",
    // Competition lobby
    lobby_welcome: "Welcome, {username}!",
    lobby_confirm_hint: "Before playing, confirm your details and set up your avatar.",
    lobby_avatar_label: "Avatar",
    lobby_avatar_hint: "Click to customize your virtual face.",
    lobby_missing_prefix: "Please fill:",
    lobby_play_btn: "Play",
    lobby_logout_btn: "Log out",
    lobby_game_label: "Game",
    lobby_tier_or_level: "Tier / Level",
    lobby_level_only: "Level",
    lobby_attempts_label: "Attempts",
    lobby_previous_results: "Previous results",
    lobby_no_results: "You have no results yet.",
    lobby_win_label: "✓ Win",
    lobby_loss_label: "✗ Loss",
    lobby_diploma_label: "Diploma",
    lobby_download_diploma: "Download diploma",
    // Teacher confirmation modal
    teacher_modal_title: "Teacher confirmation",
    teacher_modal_body: "By entering the teacher's password I confirm that the Name, School and Nationality of the student are correct!",
    teacher_password_label: "Teacher's password",
    teacher_confirm_btn: "Confirm and play",
    // Countdown before competition play
    countdown_go: "GO!",
    lobby_participation_ended: "Your participation has ended. You have no attempts left.",
    continue_btn: "Continue",
    select_placeholder: "Select",
    insc_generate_hint_tiers: "Generate credentials for your students by tier",
    insc_generate_hint_levels: "Generate credentials for your students by level",
    insc_students_per_tier: "Students per tier",
    insc_students_per_level: "Students per level",
    insc_col_tier_or_level: "Level/Tier",
    insc_col_level: "Level",
    insc_lvl_short: "Lv",
    insc_total: "Total",
    no_attempts: "You have no attempts available",
    login_error: "Invalid credentials",
    results: "Results",
    train_user_id: "Training ID",
    welcome: "Welcome",
    rank_vs_time_title: "Ranking - VS TIME",
    optional: "optional",
    back_btn: "BACK",
    exit_btn: "EXIT",
    audio_on: "AUDIO",
    audio_off: "NO AUDIO",
    ready_title: "Ready to Play?",
    lives_available: "Lives Left: {n}",
    sudden_death: "Sudden Death",
    wrong_costs: "Each wrong answer adds +{n}s to your time.",
    start_game: "START",
    demo_btn: "DEMO",
    you_won_default: "YOU WON!",
    victory: "VICTORY!",
    defeat: "DEFEAT!",
    congrats_name_bang: "Congrats, {name}!",
    wrong_answer: "Wrong answer!",
    game_end: "Game over.",
    time_label: "Time:",
    attempts_left: "Attempts left:",
    play_again: "Play again",
    try_again: "Try again",
    choose_other_game: "Choose another game",
    home_btn: "Home",
    exit_lower: "Exit",
    loading_ranking: "Loading ranking…",
    attempts_exhausted: "Attempts exhausted",
    thanks_participation: "Thanks for playing!",
    session_ends_10s: "The session ends automatically in 20 seconds…",
    thanks_participation: "Thanks for playing!",
    session_ends_in: "This session ends in 20 seconds…",
    defeated_robot: "YOU BEAT THE ROBOT!",
    robot_won: "THE ROBOT WON",
    beat_robot_duel: "You beat {robot} in a duel!",
    robot_finished_first: "{robot} completed SUPERT first.",
    you_won_points: "You earned",
    you_lost_points: "You lost",
    points_unit: "pts",
    total_points: "Total points:",
    share_my_rank: "Share my rank #{n}",
    // Eliminatorias — Lobby (i18n batch 2026-02)
    play_btn: "Play",
    dismiss_btn: "Dismiss",
    attempt_one: "attempt",
    attempt_many: "attempts",
    // Ready modal (pre-game)
    ready_elim_header: "Knockout",
    ready_elim_header_wvl: "Knockout · Wins vs Losses",
    ready_elim_attempt_x_of_y: "Attempt {current}/{total}",
    ready_elim_header_robot: "Knockout · Beat the Robot",
    ready_elim_target: "Target",
    ready_elim_used: "Used",
    ready_elim_left: "Left",
    ready_elim_wins: "Wins",
    ready_elim_losses: "Losses",
    ready_elim_games_left: "Games left",
    ready_competition_header: "Competition",
    ready_competition_used: "Used",
    ready_competition_left: "Available",
    elim_lobby_almost_there: "Almost there!",
    elim_lobby_complete_profile_hint: "Complete your profile (name, school and nationality) so you show up correctly on the finalists list.",
    elim_lobby_complete_now: "Complete now",
    elim_lobby_eyebrow: "Knockouts",
    elim_lobby_greeting: "Hi, {name}!",
    elim_lobby_default_student: "student",
    elim_lobby_profile_btn: "Profile",
    elim_lobby_logout_btn: "Log out",
    elim_lobby_load_error: "Couldn't load the lobby.",
    elim_lobby_combo_not_found: "Couldn't find that game and tier combination.",
    elim_lobby_start_error: "Couldn't start.",
    elim_lobby_no_results_title: "No results for your search.",
    elim_lobby_no_results_hint: "Try clearing the filters or searching for another term.",
    elim_share_prepare_error: "Couldn't prepare the share.",
    elim_share_download_diploma_title: "Download diploma as PDF",
    elim_share_diploma_btn: "Diploma",
    elim_share_social_title: "Share on social media",
    elim_share_share_btn: "Share",
    elim_share_dialog_title: "Share diploma",
    elim_share_preview_alt: "Diploma preview",
    elim_share_tag_instagram: "Tag @supertmatik on Instagram",
    elim_share_all_ready: "All set! Now:",
    elim_share_step1: "The diploma <strong>image</strong> has been downloaded to your device.",
    elim_share_step2: "The <strong>caption</strong> (with <code class='bg-white px-1.5 py-0.5 rounded text-pink-700 font-bold'>@supertmatik</code> + #hashtags) has been copied.",
    elim_share_step3: "Open <strong>Instagram</strong>, create a post or story, and pick the downloaded image.",
    elim_share_step4: "<strong>Paste the caption</strong> into the text field — @supertmatik will be clickable.",
    elim_share_step5: "Publish! 🎉",
    elim_share_copy_again: "Copy the caption again",
    elim_share_view_caption: "View caption",
    elim_share_info: "<strong>Instagram:</strong> use the pink button above — we copy the caption with <code class='bg-slate-100 px-1 rounded'>@supertmatik</code> and download the image. <strong>WhatsApp/Twitter/Facebook:</strong> share the link directly.",
    elim_share_download_img: "Download image",
    elim_share_copy_img: "Copy image",
    elim_share_copy_caption_btn: "Copy caption",
    elim_share_img_downloaded: "Image downloaded — now you can attach it on social media!",
    elim_share_img_copied: "Image copied — paste it wherever you like!",
    elim_share_img_copy_fail: "Your browser doesn't allow copying images. Use the Download button.",
    elim_share_clipboard_fail: "Your browser doesn't allow copying to the clipboard.",
    elim_share_caption_copied: "Caption copied!",
    elim_share_copy_fail: "Couldn't copy.",
    elim_share_caption_copied_again: "Caption copied again!",
    elim_share_copy_fail_manual: "Couldn't copy. Copy it manually below.",
    elim_share_finalist_text: "I'm a SUPERTMATIK FINALIST in {game}! 🏆 #SUPERTMATIK",
    elim_share_instagram_caption: "I'm a SUPERTMATIK FINALIST in {game}! 🏆\n\nThanks @supertmatik 💜\n#SUPERTMATIK #supertmatik #campeonatos_escolares",
    elim_share_diploma_downloaded: "Diploma downloaded!",
    elim_share_diploma_download_fail: "Couldn't download the diploma.",
    elim_share_shared: "Shared!",
    elim_share_webshare_title: "SUPERTMATIK Diploma · {game}",
    elim_profile_title: "My profile",
    elim_profile_tab_avatar: "Avatar",
    elim_profile_tab_profile: "Profile",
    elim_profile_tab_password: "Password",
    elim_profile_avatar_updated: "Avatar updated!",
    elim_profile_avatar_save_fail: "Couldn't save the avatar.",
    elim_profile_avatar_hint: "Customise your avatar — hair, eyes, clothes, colour… it'll appear next to your name on the finalists list and on the diploma.",
    elim_profile_edit_avatar: "Edit avatar",
    elim_profile_create_avatar: "Create avatar",
    elim_profile_updated: "Profile updated!",
    elim_profile_save_fail: "Couldn't save.",
    elim_profile_name_label: "Full name",
    elim_profile_name_ph: "Jane Doe",
    elim_profile_school_label: "School",
    elim_profile_school_ph: "Example School",
    elim_profile_nationality_label: "Nationality",
    elim_profile_saving: "Saving…",
    elim_profile_save_btn: "Save changes",
    elim_profile_pwd_min: "The new password must be at least 6 characters.",
    elim_profile_pwd_mismatch: "The passwords don't match.",
    elim_profile_pwd_updated: "Password updated.",
    elim_profile_pwd_update_fail: "Couldn't update.",
    elim_profile_cur_pwd_label: "Current password",
    elim_profile_new_pwd_label: "New password",
    elim_profile_confirm_label: "Confirm",
    elim_profile_new_pwd_ph: "6+ characters",
    elim_profile_confirm_ph: "repeat the new password",
    elim_profile_pwd_saving: "Updating…",
    elim_profile_pwd_save_btn: "Update password",
    elim_reset_token_missing: "Token missing from the link.",
    elim_reset_pwd_min: "The password must be at least 6 characters.",
    elim_reset_pwd_updated: "Password updated!",
    elim_reset_fail: "Couldn't update the password.",
    elim_reset_title: "New password",
    elim_reset_subtitle: "Set a new password for your Knockouts account.",
    elim_reset_all_good: "All done!",
    elim_reset_done_body: "Your password has been updated. You can now sign in with your new credentials.",
    elim_reset_goto_login: "Go to login",
    elim_reset_no_token_body: "Token missing. Request the recovery link again.",
    elim_reset_back: "← Back",
    elim_reset_confirm_ph: "repeat the password",
    elim_lobby_you_are_finalist: "You are a FINALIST!",
    elim_lobby_category_one: "category",
    elim_lobby_category_many: "categories",
    elim_lobby_finalist_categories: "Qualified in {n} {plural}. Download your diploma in the matching section below and wait for the Grand Final invitation.",
    elim_lobby_account: "Account",
    elim_lobby_no_school: "no school",
    elim_lobby_no_country: "no country",
    elim_lobby_challenges_available: "Available challenges",
    elim_lobby_complete_all_to_qualify: "Complete <strong>every</strong> knockout in a game to qualify for the Grand Final.",
    elim_lobby_continue_where: "Continue where you left off",
    elim_lobby_want_to_continue: "Want to continue your attempt of",
    elim_lobby_empty: "No active knockouts yet. Check back soon!",
    elim_lobby_search_placeholder: "Search game or tier…",
    elim_lobby_search_clear_aria: "Clear search",
    elim_lobby_filter_all: "All",
    elim_lobby_filter_in_progress: "In progress",
    elim_lobby_filter_finalist: "Finalist",
    elim_lobby_filter_not_started: "Not started",
    elim_lobby_game_label: "Game",
    elim_lobby_tier_label: "Tier",
    elim_lobby_passed_count: "passed",
    elim_lobby_finalist_badge: "Finalist",
    elim_lobby_my_active_games: "My games in progress",
    elim_lobby_explore_others: "Explore other games",
    elim_lobby_pick_a_game: "Pick a game to start",
    elim_lobby_game_available_one: "game available",
    elim_lobby_game_available_many: "games available",
    elim_lobby_x_games_available: "There are <b>{n} {plural}</b> with several tiers. Pick below to open the one you want.",
    elim_lobby_pick_game_option: "— Pick a game —",
    elim_lobby_pick_tier_option: "— Pick a tier —",
    elim_lobby_no_tiers: "— No tiers defined —",
    elim_lobby_open_btn: "Open",
    elim_lobby_back_home: "← Back to home page",
    elim_lobby_tier_done_suffix: "already completed",
    elim_lobby_tier_failed_suffix: "attempts exhausted",
    // Eliminatória card
    elim_card_label: "Knockout",
    elim_card_mode_vs_robot: "VS ROBOT",
    elim_card_mode_wvl: "WINS vs LOSSES",
    elim_card_mode_avg: "AVG TIME",
    elim_card_mental: "Mental strength",
    elim_card_wins: "Wins",
    elim_card_losses: "Losses",
    elim_card_attempts: "Attempts",
    elim_card_games_avg: "Games · Avg",
    elim_card_target: "Target",
    elim_card_attempt_failed: "Attempt failed · start a new one ({left} left)",
    elim_card_beat_robot: "Beat the robot",
    elim_card_wvl_summary: "{wins} wins in {total} games",
    elim_card_avg_summary: "avg ≤ {target}s · {games}×{attempts}",
    elim_card_target_summary: "target {seconds}s",
    elim_card_objective_label: "Objective",
    elim_card_start_game: "Start game",
    elim_card_starting: "Starting…",
    elim_card_attempts_total_label: "Attempts",
    elim_card_attempts_avail_label: "Attempts left",
    elim_hist_title: "Attempts summary",
    elim_hist_attempt: "Attempt {n}",
    elim_hist_robot_won: "You beat the robot on attempt #{n}!",
    elim_hist_robot_not_yet: "You haven't beaten the robot yet!",
    elim_hist_win_abbr: "W",
    elim_hist_loss_abbr: "L",
    elim_obj_wvl: "Win {wins} games out of {total}",
    elim_obj_robot: "Beat robot {name}",
    elim_obj_target: "Win a game within {seconds}s",
    elim_obj_avg: "Average time ≤ {target}s over {games} games",
    elim_card_status_passed: "Completed",
    elim_card_status_locked: "Locked — complete the previous",
    elim_card_status_impossible: "Impossible to pass",
    elim_card_status_exhausted: "Out of attempts",
    elim_card_continue_attempt: "Continue attempt (game {game}/{total})",
    elim_card_new_attempt: "New attempt ({left} left)",
    elim_card_remaining_one: "left",
    elim_card_remaining_many: "left",
    share_title: "Share rank #{rank}",
    share_generating: "Generating image…",
    share_image_alt: "Rank card",
    share_hint_html: "<strong>Instagram:</strong> download the image and post from your phone. <strong>WhatsApp/Twitter/Facebook:</strong> share the link directly.",
    share_btn_download: "Download",
    share_btn_copy_image: "Copy image",
    share_btn_copy_caption: "Copy caption",
    share_btn_native: "Share (system)",
    share_error_generate: "Couldn't generate the image.",
    share_toast_downloaded: "Image downloaded — share wherever you want!",
    share_toast_copied_image: "Image copied!",
    share_toast_copy_image_unsupported: "Your browser can't copy images. Use the Download button.",
    share_toast_copy_unsupported: "Browser doesn't support copy.",
    share_toast_copied_caption: "Caption copied!",
    share_toast_copy_failed: "Couldn't copy.",
    share_robot_fallback: "the robot",
    share_caption: "I just defeated {robot} on SUPERTMATIK VS ROBOT and I'm #{rank} of {total}! 🤖⚔️ #supertmatik",
    another_duel: "Another duel",
    rematch: "Rematch with {name}",
    rematch_short: "Rematch",
    play_again_with: "Play again with {name}?",
    opponent_default: "opponent",
    // Mode names (rendered as page titles / combobox labels / share captions).
    mode_vs_time: "VS TIME",
    mode_vs_robot: "VS ROBOT",
    mode_vs_human: "VS HUMAN",
    duel_one: "duel",
    duel_many: "duels",
    common_loading: "Loading…",
    preparing_game: "Getting your game ready…",
    preparing_game_hint: "Just a moment, you're about to start!",
    common_exit: "Exit",
    ranking_page_title: "Ranking",
    ranking_type_label: "Ranking type",
    choose_other_robot: "Choose another robot",
    back_to_eliminations: "Back to Knockouts",
    dont_give_up: "Don't give up — pick another robot or try another level!",
    try_again_one_attempt: "You still have 1 attempt left.",
    try_again_many_attempts: "You still have {left} attempts left.",
    attempts_left_one: "You still have 1 attempt left in this knockout.",
    attempts_left_many: "You still have {left} attempts left in this knockout.",
    no_attempts_left_sentence: "No attempts left — the knockout is over.",
    checking_attempts: "Checking remaining attempts…",
    new_attempt: "New attempt",
    calculating_ranking: "Calculating ranking…",
    won_duel: "YOU WON THE DUEL!",
    lost_duel: "YOU LOST THE DUEL",
    duel_discarded: "DUEL DISCARDED",
    opponent_disconnected: "Opponent disconnected — result was not saved.",
    tie_no_record: "Technical tie: counts as neither win nor loss.",
    lost_connection_15s: "You lost connection for more than 15s.",
    tie_not_saved: "Technical tie: result was not saved.",
    beat_in_realtime: "You beat {robot} in real time!",
    back_to_lobby: "Back to start",
    want_more_lobby: "Want more? Find another opponent in the lobby.",
    try_again_lobby: "Back to the lobby — give it another shot!",
    you_are_finalist: "YOU'RE A FINALIST!",
    knockout_passed: "KNOCKOUT PASSED!",
    almost: "ALMOST!",
    qualified_for_final: "You qualified for the Grand Final 🎉",
    target_label: "target",
    won_but_not_target: "You won, but not within the target time.",
    // Wins-vs-Losses mode messages
    wvl_won_this_game: "YOU WON!",
    wvl_lost_this_game: "DEFEAT",
    wvl_wins: "Wins",
    wvl_losses: "Losses",
    wvl_keep_going: "You still have {left} games left and need {need} more wins to pass.",
    wvl_keep_going_1g_nv: "You still have {left} game left and need {need} more wins to pass.",
    wvl_keep_going_ng_1v: "You still have {left} games left and need {need} more win to pass.",
    wvl_keep_going_1g_1v: "You still have {left} game left and need {need} more win to pass.",
    wvl_impossible: "You can no longer reach the required wins in this attempt.",
    wvl_attempt_failed_title: "Attempt failed",
    wvl_attempt_failed_hint: "This attempt was lost — you still have {left} attempt{plural} left to pass the knockout.",
    wvl_no_attempts_left: "No attempts left — knockout failed.",
    wvl_start_new_attempt: "Start a new attempt",
    wvl_play_next: "Play next",
    // AVG-TIME mode (2026-02) — average time across N attempts.
    avg_time_impossible_title: "Not possible anymore :(",
    avg_time_progress_title: "Nice! Game finished",
    avg_time_attempts: "Attempts",
    avg_time_current: "Current avg",
    avg_time_target: "Target avg",
    avg_time_next_hint: "Do the next in ≤ {seconds}s to keep the target reachable.",
    avg_time_terminated_hint: "Even with 0 seconds on the remaining games you can't hit the target. Knockout failed.",
    avg_time_play_next: "Play next",
    avg_time_aborted_title: "You lost this game",
    avg_time_aborted_hint: "In Average Time mode, every game must be won. Knockout is over.",
    // v2 (2026-02): multi-attempt semantics
    avg_time_games_col: "Games",
    avg_time_attempts_left_col: "Attempts left",
    avg_time_attempt_x_of_y: "Attempt {current} of {total}",
    avg_time_next_game_hint: "Do the next in ≤ {seconds}s to stay within the target average!",
    avg_time_play_next_in_attempt: "Play next ({current}/{total})",
    avg_time_start_new_attempt: "Start new attempt",
    avg_time_attempt_lost_title: "Attempt failed",
    avg_time_attempt_lost_hint: "You lost a game — this attempt failed (every game must be won).",
    avg_time_attempt_slow_title: "Average too high",
    avg_time_attempt_slow_hint: "You finished the games but the average was above target. This attempt failed.",
    avg_time_attempt_unreachable_title: "Target average out of reach",
    avg_time_attempt_unreachable_hint: "Even if the remaining games took 0 seconds, the average would stay above target. This attempt was marked as failed.",
    avg_time_attempts_left_hint: "You still have {left} attempt{plural} left.",
    avg_time_no_attempts_left: "No attempts left — knockout failed.",
    attempts_remaining_this_elim: "Attempts remaining in this knockout:",
    did_not_pass: "DID NOT PASS",
    failed_attempt: "Failed attempt",
    each_new_attempt_costs: "Each new attempt uses 1 of your available attempts.",
    knockout_label: "Knockout",
    passed_uppercase: "PASSED!",
    knockout_now_complete: "This knockout is now complete.",
    elim_info_title: "Student details",
    elim_info_student: "Student",
    elim_info_school: "School",
    elim_info_game: "Game",
    elim_info_level: "Tier / Level",
    avatar_customize: "Customize your avatar",
    random: "Random",
    male: "Male",
    female: "Female",
    bg_color: "Background colour",
    save_btn: "Save",
    ava_hair: "Hair",
    ava_eyes: "Eyes",
    ava_eyebrows: "Eyebrows",
    ava_mouth: "Mouth",
    ava_glasses: "Glasses",
    ava_clothes: "Clothes",
    ava_skin: "Skin",
    ava_haircolor: "Hair colour",
    ava_clothecolor: "Clothes colour",
    ava_beard: "Beard",
    ava_beardcolor: "Beard colour",
    vsr_hero_title_left: "VS",
    vsr_hero_title_right: "",
    vsr_hero_desc: "Our robots are rated based on three parameters: response speed, accuracy rate, and mental strength. Every time you defeat a robot, you earn ranking points equal to twice its mental strength. But be careful! If you are defeated, you will lose points equal to half the mental strength of the robot that defeated you.",
    vsr_step_name: "What's your name?",
    train_name_required: "Please enter your name to start.",
    train_nationality_required: "Choose your nationality.",
    train_game_required: "Pick a game.",
    vsr_load_failed: "Couldn't load.",
    vsr_pick_robot: "Pick a robot opponent.",
    vsr_missing_fields: "Missing {n} fields: {list}",
    vsh_invite_declined: "Invite declined.",
    vsh_private_code_ready: "Code ready: {code}",
    vsh_name_required: "Please enter your name.",
    vsh_invite_sent: "Invite sent to {name}",
    vsh_invite_expired: "No response — invite expired.",
    vsh_invite_timeout_auto_decline: "Time's up — invite was auto-declined.",
    vsh_rematch_waiting: "Waiting for {name} to come back for a rematch…",
    vsh_rematch_unavailable: "{name} didn't come back to the lobby — no rematch this time.",
    vsh_rematch_offline: "Opponent unavailable — rematch cancelled.",
    vsh_rematch_declined: "{name} declined the rematch.",
    vsh_rematch_prompt: "Rematch?",
    vsh_rematch_prompt_sub: "{name} wants an instant rematch!",
    vsh_rematch_accept: "Accept Rematch",
    vsh_rematch_decline: "Not now",
    vsh_playagain_prompt: "New game?",
    vsh_playagain_prompt_sub: "{name} wants to play again with you!",
    vsh_playagain_accept: "Accept",
    vsh_playagain_decline: "Not now",
    vsh_copied: "Copied!",
    vsh_error_generic: "Error",
    vsh_fill_field_before_room: "Fill in your {field} before creating a room.",
    vsh_fill_missing_fields: "Please fill in the missing fields: {list}.",
    vsh_field_name: "name",
    vsh_field_game: "game",
    vsh_field_code: "4-digit code",
    vsh_pick_code: "Please enter a 4-digit code.",
    // VS HUMANO — lobby / UI copy (2026-02)
    vsh_connecting: "connecting…",
    vsh_page_intro: "Play a real-time duel against another human. Pick your own game and level/tier — you'll only see peers who chose the same game as you, but each player plays at their own level.",
    vsh_invite_expire_tip: "Time until invite expires",
    vsh_step_choose_game: "Pick a game",
    vsh_step_choose_level: "Pick a level",
    vsh_step_who_online: "Who's online?",
    vsh_hint_pick_game_first: "Pick a game first",
    vsh_hint_pick_name: "Enter your name",
    vsh_level_or_tier: "Level / Tier",
    vsh_level_label: "Level",
    vsh_searching: "Looking for opponents…",
    vsh_searching_sub_html: "Other online players who <b>picked this same game</b> will show up here. Each plays their own level/tier — first to complete SUPERT wins.",
    vsh_challenge: "Challenge",
    vsh_waiting_short: "Waiting…",
    vsh_private_title: "PRIVATE DUEL",
    vsh_private_host_title: "Create code (host)",
    vsh_private_generate: "Generate code",
    vsh_private_enter_title: "Enter code",
    vsh_private_enter_btn: "Join",
    vsh_private_hint: "Agree on the code with a friend. The host sets the game & level.",
    vsh_back_home: "← Back to home",
    vsh_invite_title: "Duel invite!",
    vsh_invite_sub: "<b>{name}</b> wants to challenge you.",
    vsh_invite_countdown_prefix: "Auto decision in",
    vsh_accept: "Accept",
    vsh_reject: "Decline",
    vsr_step_game: "Choose a game",
    vsr_step_level: "Choose your level",
    vsr_step_robot: "Pick your robot opponent",
    vsr_pick_game_first: "Choose a game first",
    vsr_loading: "Loading…",
    vsr_no_games: "No games available.",
    vsr_no_robots: "No robots configured for this game yet. Ask the admin to create one.",
    vsr_start_duel: "Start duel",
    back_to_home: "Back to home",
    levels_label: "Levels",
    tiers_label: "Categories",
    yes: "Yes",
    no: "No",
    lives_lost_title: "You lost a life!",
    lives_used: "Lives used",
    lives_remaining: "Remaining",
    penalty_applied: "Penalty applied",
    continue_btn: "CONTINUE",
    logout: "Log Out",
    logout_confirm: "Are you sure you want to log out?",
    logout_warn_loss: "This match will count as a loss!",
    welcome_back: "Hi",
    edit_btn: "Edit",
    rank_competition_title: "Ranking - Competition",
    col_game: "GAME",
    col_level: "LEVEL",
    col_level_or_tier: "LEVEL/CATEGORY",
    col_name: "NAME",
    col_school: "SCHOOL",
    col_best_time: "BEST TIME",
    col_share: "SHARE",
    all_levels: "All levels",
    all_tiers: "All categories",
    // ── Eliminatórias landing page (EN) ────────────────────────────────
    elim_landing_eyebrow: "SUPERTMATIK Knockouts",
    elim_landing_title_prefix: "On the road to the",
    elim_landing_title_highlight: "Grand Final",
    elim_landing_title_suffix: "!",
    elim_landing_subtitle: "Create your student account, beat the knockouts of your favourite game and earn a spot in the Grand Final.",
    elim_landing_how_it_works: "How it works",
    elim_landing_step_1: "Create your account — just a username, email and password.",
    elim_landing_step_2: "Complete your profile with name, school and nationality.",
    elim_landing_step_3: "Pick an available knockout and beat the challenge.",
    elim_landing_step_4: "Clear every knockout for the same game and qualify for the Grand Final!",
    elim_landing_important_label: "Important:",
    elim_landing_important_body: "your Knockouts account is separate from the training/competition credentials. Each student has their own.",
    elim_landing_tab_login: "Log in",
    elim_landing_tab_register: "Create account",
    elim_landing_tab_forgot: "Recover",
    elim_landing_back_home: "← Back to the home page",
    elim_login_username_label: "Username or email",
    elim_login_username_ph: "e.g. anna_smith or anna@school.com",
    elim_login_password_ph: "••••••••",
    elim_login_submit: "Log in",
    elim_login_submitting: "Logging in…",
    elim_reg_username_label: "Username*",
    elim_reg_username_ph: "anna_smith",
    elim_reg_email_label: "Email*",
    elim_reg_email_ph: "anna@school.com",
    elim_reg_password_label: "Password*",
    elim_reg_password_ph: "6+ characters",
    elim_reg_confirm_label: "Confirm*",
    elim_reg_confirm_ph: "repeat the password",
    elim_reg_profile_hint: "Profile (optional — you can fill this later)",
    elim_reg_name_label: "Full name",
    elim_reg_name_ph: "Anna Smith",
    elim_reg_school_label: "School",
    elim_reg_school_ph: "e.g. St. Mary's",
    elim_reg_nationality_label: "Nationality",
    elim_reg_submit: "Create account and enter",
    elim_reg_submitting: "Creating account…",
    elim_reg_has_account: "Already have an account?",
    elim_reg_go_login: "Log in here",
    elim_forgot_hint: "Enter the email linked to your Knockouts account and we'll send you a link to set a new password.",
    elim_forgot_email_label: "Email",
    elim_forgot_submit: "Send recovery link",
    elim_forgot_submitting: "Sending…",
    elim_forgot_back: "← Back to login",
    elim_forgot_request_sent: "Request sent!",
    elim_forgot_request_body: "If the email exists in our database, you've received a link to set a new password (valid for 1 hour).",
    elim_forgot_test_mode_label: "Test mode (email MOCKED):",
    elim_forgot_test_mode_hint: "use this link to continue.",
    elim_forgot_open_reset: "Open reset link",
    err_fill_all: "Please fill in all fields.",
    err_login_failed: "Could not log in.",
    err_register_failed: "Could not create the account.",
    err_required_fields: "Username, email and password are required.",
    err_password_too_short: "The password must have at least 6 characters.",
    err_passwords_no_match: "Passwords do not match.",
    err_forgot_failed: "Could not process the request.",
    ok_welcome_named: "Welcome, {name}!",
    ok_account_created: "Account created successfully!",
  },
  es: {
    nav_home: "Inicio",
    nav_admin: "Admin",
    home_title: "SUPERTMATIK",
    home_subtitle: "Aprende a jugar, juega para aprender",
    rules_title: "Reglamento",
    train_start: "",
    level_or_tier: "Nivel/Categoría",
    level_paren: "Nivel",
    view_ranking_vs_time: "Ver ranking VS Tiempo",
    your_name: "Tu nombre",
    your_nationality: "Nacionalidad",
    select_game: "Elegir juego",
    play: "Jugar",
    login: "Entrar",
    username: "Usuario",
    password: "Contraseña",
    logout: "Salir",
    rotate_device_title: "Gira el dispositivo",
    rotate_device_body: "Para jugar, gira tu teléfono/tablet a la posición horizontal (landscape).",
    rotate_to_portrait_title: "Gira el teléfono",
    rotate_to_portrait_body: "Esta pantalla solo está disponible en posición vertical (portrait). Gira tu teléfono para continuar.",
    competition: "Competición",
    training: "VS Tiempo",
    rankings: "Clasificaciones",
    ranking: "Puesto",
    name: "Nombre",
    school: "Centro educativo",
    nationality: "Nacionalidad",
    best_time: "Mejor Tiempo",
    attempts: "Intentos",
    download_diploma: "Descargar Diploma",
    diploma_indiv: "Diploma Individual",
    diploma_bulk: "Diplomas en Masa",
    school_register: "Inscribir Escuela",
    email: "Email",
    submit: "Enviar",
    available_attempts: "Tienes {n} intentos disponibles",
    exit_warning_title: "Salir ahora contará como una derrota.",
    exit_warning_subtitle: "¿Estás seguro de que quieres salir?",
    start: "Empezar",
    abandon: "Abandonar",
    correct: "¡Correcto!",
    wrong: "¡Incorrecto!",
    game_over: "Fin del juego",
    you_won: "¡Felicidades! ¡Completaste SUPERT!",
    spin_roulette: "Girar Ruleta",
    time: "Tiempo",
    dashboard: "Dashboard",
    metrics: "Métricas",
    settings: "Ajustes Generales",
    main_settings: "Ajustes principales",
    ads: "Publicidad",
    section_general: "General",
    section_games_content: "Contenido del Juego",
    section_users: "Usuarios",
    section_appearance: "Pie de página",
    section_texts: "Textos",
    games: "Juegos",
    questions: "Preguntas",
    credentials: "Credenciales Competición",
    inscriptions: "Inscripciones de Finalistas",
    payments: "Pagos",
    training_users: "Usuarios Entrenamiento",
    competition_users: "Usuarios Competición",
    comp_results_title: "Resultados Gran Final",
    comp_results_intro: "Clasificación de los juegos de competición, por grado/nivel, jugados con credenciales.",
    elim_users: "Eliminatorias Escolares",
    elim_challenges: "Eliminatorias · Desafíos",
    robots: "Robots",
    vsrobot_users: "Usuarios VS Robot",
    vshuman_users: "Usuarios VS Humano",
    demo_phrases: "DEMO — Aprende a Jugar",
    grande_final: "Gran Final",
    roulette: "Ruleta",
    diplomas: "Diplomas",
    messages: "Mensajes",
    regulamento: "Reglamento",
    search_edit_texts: "Buscar y Editar",
    i18n_coverage: "Cobertura PT/EN/ES",
    db_migration: "Migración de Datos",
    pending_results: "Resultados Pendientes",
    themes: "Temas",
    home_buttons: "Botones Home",
    footer: "Pie de página",
    test_zone: "Zona de Pruebas",
    intro: "Intro",
    results: "Resultados",
    create: "Crear",
    edit: "Editar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    save: "Guardar",
    cancel: "Cancelar",
    active: "Activo",
    inactive: "Inactivo",
    mode_normal: "Normal",
    mode_sem_sorte: "Sin Suerte",
    status_training: "VS Tiempo",
    status_competition: "Competición",
    status_both: "Ambos",
    status_eliminatorias: "Eliminatorias",
    upload_excel: "Importar Excel",
    export_excel: "Exportar Excel",
    generate: "Generar",
    quantity: "Cantidad",
    students_count: "N.º alumnos",
    level: "Nivel",
    diploma_unavailable: "Diploma no disponible. ¡Vuelve más tarde!",
    diploma_not_yet_available: "Aún no disponible",
    // Competition lobby
    lobby_welcome: "¡Bienvenido, {username}!",
    lobby_confirm_hint: "Antes de jugar, confirma tus datos y configura tu avatar.",
    lobby_avatar_label: "Avatar",
    lobby_avatar_hint: "Haz clic para personalizar tu cara virtual.",
    lobby_missing_prefix: "Faltan:",
    lobby_play_btn: "Jugar",
    lobby_logout_btn: "Cerrar sesión",
    lobby_game_label: "Juego",
    lobby_tier_or_level: "Nivel / Grado",
    lobby_level_only: "Nivel",
    lobby_attempts_label: "Intentos",
    lobby_previous_results: "Resultados anteriores",
    lobby_no_results: "Aún no tienes resultados.",
    lobby_win_label: "✓ Victoria",
    lobby_loss_label: "✗ Derrota",
    lobby_diploma_label: "Diploma",
    lobby_download_diploma: "Descargar diploma",
    // Teacher confirmation modal
    teacher_modal_title: "Confirmación del profesor",
    teacher_modal_body: "Al introducir la contraseña del profesor confirmo que el Nombre, Centro educativo y Nacionalidad del/de la alumno/a son correctos.",
    teacher_password_label: "Contraseña del profesor",
    teacher_confirm_btn: "Confirmar y jugar",
    // Countdown before competition play
    countdown_go: "¡YA!",
    lobby_participation_ended: "Ya has terminado tu participación. No tienes más intentos disponibles.",
    continue_btn: "Continuar",
    select_placeholder: "Selecciona",
    insc_generate_hint_tiers: "Genera credenciales para tus alumnos por grado",
    insc_generate_hint_levels: "Genera credenciales para tus alumnos por nivel",
    insc_students_per_tier: "Alumnos por grado",
    insc_students_per_level: "Alumnos por nivel",
    insc_col_tier_or_level: "Nivel/Grado",
    insc_col_level: "Nivel",
    insc_lvl_short: "Nv",
    insc_total: "Total",
    no_attempts: "No tienes intentos disponibles",
    login_error: "Credenciales inválidas",
    results: "Resultados",
    train_user_id: "ID Entrenamiento",
    welcome: "Bienvenido",
    rank_vs_time_title: "Ranking - VS TIEMPO",
    optional: "opcional",
    back_btn: "VOLVER",
    exit_btn: "SALIR",
    audio_on: "SONIDO",
    audio_off: "SIN SONIDO",
    ready_title: "¿Listo para jugar?",
    lives_available: "Vidas restantes: {n}",
    sudden_death: "Muerte súbita",
    wrong_costs: "Cada respuesta incorrecta añade +{n}s al tiempo.",
    start_game: "INICIAR JUEGO",
    demo_btn: "DEMO",
    you_won_default: "¡GANASTE!",
    victory: "¡VICTORIA!",
    defeat: "¡DERROTA!",
    congrats_name_bang: "¡Felicidades, {name}!",
    wrong_answer: "¡Respuesta incorrecta!",
    game_end: "Fin del juego.",
    time_label: "Tiempo:",
    attempts_left: "Intentos restantes:",
    play_again: "Jugar de nuevo",
    try_again: "Inténtalo de nuevo",
    choose_other_game: "Elegir otro juego",
    home_btn: "Inicio",
    exit_lower: "Salir",
    loading_ranking: "Cargando ranking…",
    attempts_exhausted: "Intentos agotados",
    thanks_participation: "¡Gracias por participar!",
    session_ends_10s: "La sesión termina automáticamente en 20 segundos…",
    thanks_participation: "¡Gracias por participar!",
    session_ends_in: "La sesión terminará en 20 segundos…",
    defeated_robot: "¡VENCISTE AL ROBOT!",
    robot_won: "EL ROBOT GANÓ",
    beat_robot_duel: "¡Venciste a {robot} en un duelo!",
    robot_finished_first: "{robot} completó SUPERT primero.",
    you_won_points: "Ganaste",
    you_lost_points: "Perdiste",
    points_unit: "pts",
    total_points: "Puntos acumulados:",
    share_my_rank: "Compartir mi posición #{n}",
    // Eliminatorias — Lobby (i18n batch 2026-02)
    play_btn: "Jugar",
    dismiss_btn: "Descartar",
    attempt_one: "intento",
    attempt_many: "intentos",
    // Ready modal (pre-game)
    ready_elim_header: "Eliminatoria",
    ready_elim_header_wvl: "Eliminatoria · Victorias vs Derrotas",
    ready_elim_attempt_x_of_y: "Intento {current}/{total}",
    ready_elim_header_robot: "Eliminatoria · Vencer al Robot",
    ready_elim_target: "Objetivo",
    ready_elim_used: "Usadas",
    ready_elim_left: "Restantes",
    ready_elim_wins: "Victorias",
    ready_elim_losses: "Derrotas",
    ready_elim_games_left: "Juegos restantes",
    ready_competition_header: "Competición",
    ready_competition_used: "Utilizadas",
    ready_competition_left: "Disponibles",
    elim_lobby_almost_there: "¡Casi!",
    elim_lobby_complete_profile_hint: "Completa tu perfil (nombre, escuela y nacionalidad) para aparecer correctamente en la lista de finalistas.",
    elim_lobby_complete_now: "Completar ahora",
    elim_lobby_eyebrow: "Eliminatorias",
    elim_lobby_greeting: "¡Hola, {name}!",
    elim_lobby_default_student: "alumno",
    elim_lobby_profile_btn: "Perfil",
    elim_lobby_logout_btn: "Salir",
    elim_lobby_load_error: "No se pudo cargar el lobby.",
    elim_lobby_combo_not_found: "No encontré esa combinación de juego y categoría.",
    elim_lobby_start_error: "No se pudo iniciar.",
    elim_lobby_no_results_title: "Sin resultados para tu búsqueda.",
    elim_lobby_no_results_hint: "Intenta borrar los filtros o buscar otro término.",
    elim_share_prepare_error: "No se pudo preparar la compartición.",
    elim_share_download_diploma_title: "Descargar diploma en PDF",
    elim_share_diploma_btn: "Diploma",
    elim_share_social_title: "Compartir en redes sociales",
    elim_share_share_btn: "Compartir",
    elim_share_dialog_title: "Compartir diploma",
    elim_share_preview_alt: "Vista previa del diploma",
    elim_share_tag_instagram: "Etiquetar a @supertmatik en Instagram",
    elim_share_all_ready: "¡Todo listo! Ahora:",
    elim_share_step1: "La <strong>imagen</strong> del diploma se ha descargado en tu dispositivo.",
    elim_share_step2: "El <strong>texto</strong> (con <code class='bg-white px-1.5 py-0.5 rounded text-pink-700 font-bold'>@supertmatik</code> + #hashtags) se ha copiado.",
    elim_share_step3: "Abre <strong>Instagram</strong>, crea una publicación o historia y elige la imagen descargada.",
    elim_share_step4: "<strong>Pega el texto</strong> en el campo — @supertmatik quedará clicable.",
    elim_share_step5: "¡Publica! 🎉",
    elim_share_copy_again: "Volver a copiar el texto",
    elim_share_view_caption: "Ver texto",
    elim_share_info: "<strong>Instagram:</strong> usa el botón rosa de arriba — copiamos el texto con <code class='bg-slate-100 px-1 rounded'>@supertmatik</code> y descargamos la imagen. <strong>WhatsApp/Twitter/Facebook:</strong> comparte el enlace directamente.",
    elim_share_download_img: "Descargar imagen",
    elim_share_copy_img: "Copiar imagen",
    elim_share_copy_caption_btn: "Copiar texto",
    elim_share_img_downloaded: "¡Imagen descargada — ya puedes adjuntarla en redes!",
    elim_share_img_copied: "¡Imagen copiada — pégala donde quieras!",
    elim_share_img_copy_fail: "Tu navegador no permite copiar imágenes. Usa el botón Descargar.",
    elim_share_clipboard_fail: "Tu navegador no permite copiar al portapapeles.",
    elim_share_caption_copied: "¡Texto copiado!",
    elim_share_copy_fail: "No se pudo copiar.",
    elim_share_caption_copied_again: "¡Texto copiado de nuevo!",
    elim_share_copy_fail_manual: "No se pudo copiar. Cópialo manualmente abajo.",
    elim_share_finalist_text: "¡Soy FINALISTA SUPERTMATIK en {game}! 🏆 #SUPERTMATIK",
    elim_share_instagram_caption: "¡Soy FINALISTA SUPERTMATIK en {game}! 🏆\n\nGracias @supertmatik 💜\n#SUPERTMATIK #supertmatik #campeonatos_escolares",
    elim_share_diploma_downloaded: "¡Diploma descargado!",
    elim_share_diploma_download_fail: "No se pudo descargar el diploma.",
    elim_share_shared: "¡Compartido!",
    elim_share_webshare_title: "Diploma SUPERTMATIK · {game}",
    elim_profile_title: "Mi perfil",
    elim_profile_tab_avatar: "Avatar",
    elim_profile_tab_profile: "Perfil",
    elim_profile_tab_password: "Contraseña",
    elim_profile_avatar_updated: "¡Avatar actualizado!",
    elim_profile_avatar_save_fail: "No se pudo guardar el avatar.",
    elim_profile_avatar_hint: "Personaliza tu avatar — pelo, ojos, ropa, color… aparecerá junto a tu nombre en la lista de finalistas y en el diploma.",
    elim_profile_edit_avatar: "Editar avatar",
    elim_profile_create_avatar: "Crear avatar",
    elim_profile_updated: "¡Perfil actualizado!",
    elim_profile_save_fail: "No se pudo guardar.",
    elim_profile_name_label: "Nombre completo",
    elim_profile_name_ph: "Ana García",
    elim_profile_school_label: "Escuela",
    elim_profile_school_ph: "Escuela Ejemplo",
    elim_profile_nationality_label: "Nacionalidad",
    elim_profile_saving: "Guardando…",
    elim_profile_save_btn: "Guardar cambios",
    elim_profile_pwd_min: "La nueva contraseña debe tener al menos 6 caracteres.",
    elim_profile_pwd_mismatch: "Las contraseñas no coinciden.",
    elim_profile_pwd_updated: "Contraseña actualizada.",
    elim_profile_pwd_update_fail: "No se pudo actualizar.",
    elim_profile_cur_pwd_label: "Contraseña actual",
    elim_profile_new_pwd_label: "Nueva contraseña",
    elim_profile_confirm_label: "Confirmar",
    elim_profile_new_pwd_ph: "6+ caracteres",
    elim_profile_confirm_ph: "repite la nueva contraseña",
    elim_profile_pwd_saving: "Actualizando…",
    elim_profile_pwd_save_btn: "Actualizar contraseña",
    elim_reset_token_missing: "Falta el token en el enlace.",
    elim_reset_pwd_min: "La contraseña debe tener al menos 6 caracteres.",
    elim_reset_pwd_updated: "¡Contraseña actualizada!",
    elim_reset_fail: "No se pudo actualizar la contraseña.",
    elim_reset_title: "Nueva contraseña",
    elim_reset_subtitle: "Define una nueva contraseña para tu cuenta de Eliminatorias.",
    elim_reset_all_good: "¡Todo listo!",
    elim_reset_done_body: "Tu contraseña se ha actualizado. Ya puedes entrar con las nuevas credenciales.",
    elim_reset_goto_login: "Ir al inicio de sesión",
    elim_reset_no_token_body: "Falta el token. Solicita de nuevo el enlace de recuperación.",
    elim_reset_back: "← Volver",
    elim_reset_confirm_ph: "repite la contraseña",
    elim_lobby_you_are_finalist: "¡Eres FINALISTA!",
    elim_lobby_category_one: "categoría",
    elim_lobby_category_many: "categorías",
    elim_lobby_finalist_categories: "Clasificado en {n} {plural}. Descarga tu diploma en la sección correspondiente y espera la convocatoria a la Gran Final.",
    elim_lobby_account: "Cuenta",
    elim_lobby_no_school: "sin escuela",
    elim_lobby_no_country: "sin país",
    elim_lobby_challenges_available: "Desafíos disponibles",
    elim_lobby_complete_all_to_qualify: "Completa <strong>todas</strong> las eliminatorias de un juego para clasificarte a la Gran Final.",
    elim_lobby_continue_where: "Continuar donde lo dejaste",
    elim_lobby_want_to_continue: "¿Quieres continuar el intento de",
    elim_lobby_empty: "Aún no hay eliminatorias activas. ¡Vuelve pronto!",
    elim_lobby_search_placeholder: "Buscar juego o nivel…",
    elim_lobby_search_clear_aria: "Limpiar búsqueda",
    elim_lobby_filter_all: "Todos",
    elim_lobby_filter_in_progress: "En curso",
    elim_lobby_filter_finalist: "Finalista",
    elim_lobby_filter_not_started: "Por empezar",
    elim_lobby_game_label: "Juego",
    elim_lobby_tier_label: "Nivel",
    elim_lobby_passed_count: "pasadas",
    elim_lobby_finalist_badge: "Finalista",
    elim_lobby_my_active_games: "Mis juegos en curso",
    elim_lobby_explore_others: "Explorar otros juegos",
    elim_lobby_pick_a_game: "Elige un juego para empezar",
    elim_lobby_game_available_one: "juego disponible",
    elim_lobby_game_available_many: "juegos disponibles",
    elim_lobby_x_games_available: "Hay <b>{n} {plural}</b> con varios niveles. Selecciona abajo para abrir el que te interese.",
    elim_lobby_pick_game_option: "— Elige un juego —",
    elim_lobby_pick_tier_option: "— Elige un nivel —",
    elim_lobby_no_tiers: "— Sin niveles definidos —",
    elim_lobby_open_btn: "Abrir",
    elim_lobby_back_home: "← Volver a la página inicial",
    elim_lobby_tier_done_suffix: "ya completado",
    elim_lobby_tier_failed_suffix: "intentos agotados",
    // Tarjeta de eliminatoria
    elim_card_label: "Eliminatoria",
    elim_card_mode_vs_robot: "VS ROBOT",
    elim_card_mode_wvl: "VICTORIAS vs DERROTAS",
    elim_card_mode_avg: "TIEMPO MEDIO",
    elim_card_mental: "Fuerza mental",
    elim_card_wins: "Victorias",
    elim_card_losses: "Derrotas",
    elim_card_attempts: "Intentos",
    elim_card_games_avg: "Juegos · Media",
    elim_card_target: "Objetivo",
    elim_card_attempt_failed: "Intento fallido · empieza uno nuevo ({left} restantes)",
    elim_card_beat_robot: "Vence al robot",
    elim_card_wvl_summary: "{wins} victorias en {total} juegos",
    elim_card_avg_summary: "media ≤ {target}s · {games}×{attempts}",
    elim_card_target_summary: "objetivo {seconds}s",
    elim_card_objective_label: "Objetivo",
    elim_card_start_game: "Iniciar juego",
    elim_card_starting: "Iniciando…",
    elim_card_attempts_total_label: "Intentos",
    elim_card_attempts_avail_label: "Intentos disponibles",
    elim_hist_title: "Resumen de intentos",
    elim_hist_attempt: "Intento {n}",
    elim_hist_robot_won: "¡Venciste al robot en el intento n.º {n}!",
    elim_hist_robot_not_yet: "¡Aún no has vencido al robot!",
    elim_hist_win_abbr: "V",
    elim_hist_loss_abbr: "D",
    elim_obj_wvl: "Ganar {wins} juegos de {total}",
    elim_obj_robot: "Vencer al robot {name}",
    elim_obj_target: "Conseguir una victoria en {seconds}s",
    elim_obj_avg: "Tiempo medio ≤ {target}s en {games} juegos",
    elim_card_status_passed: "Completada",
    elim_card_status_locked: "Bloqueada — completa la anterior",
    elim_card_status_impossible: "Imposible pasar",
    elim_card_status_exhausted: "Intentos agotados",
    elim_card_continue_attempt: "Continuar intento (juego {game}/{total})",
    elim_card_new_attempt: "Nuevo intento ({left} restantes)",
    elim_card_remaining_one: "restante",
    elim_card_remaining_many: "restantes",
    share_title: "Compartir posición #{rank}",
    share_generating: "Generando imagen…",
    share_image_alt: "Tarjeta de posición",
    share_hint_html: "<strong>Instagram:</strong> descarga la imagen y publica desde el móvil. <strong>WhatsApp/Twitter/Facebook:</strong> comparte el enlace directamente.",
    share_btn_download: "Descargar",
    share_btn_copy_image: "Copiar imagen",
    share_btn_copy_caption: "Copiar leyenda",
    share_btn_native: "Compartir (sistema)",
    share_error_generate: "No se pudo generar la imagen.",
    share_toast_downloaded: "¡Imagen descargada — compártela donde quieras!",
    share_toast_copied_image: "¡Imagen copiada!",
    share_toast_copy_image_unsupported: "Tu navegador no permite copiar imágenes. Usa el botón Descargar.",
    share_toast_copy_unsupported: "El navegador no soporta la copia.",
    share_toast_copied_caption: "¡Leyenda copiada!",
    share_toast_copy_failed: "No se pudo copiar.",
    share_robot_fallback: "el robot",
    share_caption: "¡Acabo de derrotar a {robot} en SUPERTMATIK VS ROBOT y estoy en el #{rank} de {total}! 🤖⚔️ #supertmatik",
    another_duel: "Otro duelo",
    rematch: "Revancha con {name}",
    rematch_short: "Revancha",
    play_again_with: "¿Jugar otra vez con {name}?",
    opponent_default: "rival",
    // Mode names (rendered as page titles / combobox labels / share captions).
    mode_vs_time: "VS TIEMPO",
    mode_vs_robot: "VS ROBOT",
    mode_vs_human: "VS HUMANO",
    duel_one: "duelo",
    duel_many: "duelos",
    common_loading: "Cargando…",
    preparing_game: "Preparando tu juego…",
    preparing_game_hint: "Un momento, ¡estás a punto de empezar!",
    common_exit: "Salir",
    ranking_page_title: "Clasificación",
    ranking_type_label: "Tipo de clasificación",
    choose_other_robot: "Elegir otro robot",
    back_to_eliminations: "Volver a eliminatorias",
    dont_give_up: "¡No te rindas — elige otro robot o prueba otro nivel!",
    try_again_one_attempt: "Aún te queda 1 intento.",
    try_again_many_attempts: "Aún te quedan {left} intentos.",
    attempts_left_one: "Aún te queda 1 intento en esta eliminatoria.",
    attempts_left_many: "Aún te quedan {left} intentos en esta eliminatoria.",
    no_attempts_left_sentence: "Ya no te quedan intentos — la eliminatoria ha terminado.",
    checking_attempts: "Comprobando intentos restantes…",
    new_attempt: "Nuevo intento",
    calculating_ranking: "Calculando ranking…",
    won_duel: "¡GANASTE EL DUELO!",
    lost_duel: "PERDISTE EL DUELO",
    duel_discarded: "DUELO DESCARTADO",
    opponent_disconnected: "El oponente se desconectó — el resultado no se guardó.",
    tie_no_record: "Empate técnico: no cuenta como victoria ni derrota.",
    lost_connection_15s: "Perdiste la conexión durante más de 15 segundos.",
    tie_not_saved: "Empate técnico: el resultado no se guardó.",
    beat_in_realtime: "¡Venciste a {robot} en tiempo real!",
    back_to_lobby: "Volver al inicio",
    want_more_lobby: "¿Quieres más? Encuentra otro oponente en el lobby.",
    try_again_lobby: "¡Vuelve al lobby e inténtalo de nuevo!",
    you_are_finalist: "¡ERES FINALISTA!",
    knockout_passed: "¡ELIMINATORIA SUPERADA!",
    almost: "¡CASI!",
    qualified_for_final: "Te has clasificado para la Gran Final 🎉",
    target_label: "objetivo",
    won_but_not_target: "Ganaste el juego, pero no dentro del tiempo objetivo.",
    // Wins-vs-Losses (victorias vs derrotas) mode messages
    wvl_won_this_game: "¡VICTORIA!",
    wvl_lost_this_game: "DERROTA",
    wvl_wins: "Victorias",
    wvl_losses: "Derrotas",
    wvl_keep_going: "Aún tienes {left} juegos y necesitas {need} victorias más para pasar.",
    wvl_keep_going_1g_nv: "Aún tienes {left} juego y necesitas {need} victorias más para pasar.",
    wvl_keep_going_ng_1v: "Aún tienes {left} juegos y necesitas {need} victoria más para pasar.",
    wvl_keep_going_1g_1v: "Aún tienes {left} juego y necesitas {need} victoria más para pasar.",
    wvl_impossible: "Ya no es posible alcanzar las victorias necesarias en este intento.",
    wvl_attempt_failed_title: "Intento fallado",
    wvl_attempt_failed_hint: "Este intento se perdió — aún tienes {left} intento{plural} para pasar la eliminatoria.",
    wvl_no_attempts_left: "Ya no te quedan intentos — eliminatoria fallada.",
    wvl_start_new_attempt: "Comenzar nuevo intento",
    wvl_play_next: "Jugar siguiente",
    // AVG-TIME mode (2026-02) — average time across N attempts.
    avg_time_impossible_title: "Ya no es posible :(",
    avg_time_progress_title: "¡Bien! Juego terminado",
    avg_time_attempts: "Intentos",
    avg_time_current: "Media actual",
    avg_time_target: "Media objetivo",
    avg_time_next_hint: "Haz el siguiente en ≤ {seconds}s para mantener el objetivo posible.",
    avg_time_terminated_hint: "Aunque hagas 0 segundos en los juegos restantes, no llegas a la media objetivo. Eliminatoria fallida.",
    avg_time_play_next: "Jugar siguiente",
    avg_time_aborted_title: "Perdiste este juego",
    avg_time_aborted_hint: "En el modo Tiempo Medio, cada juego debe ganarse. La eliminatoria terminó.",
    // v2 (2026-02): multi-attempt semantics
    avg_time_games_col: "Juegos",
    avg_time_attempts_left_col: "Int. restantes",
    avg_time_attempt_x_of_y: "Intento {current} de {total}",
    avg_time_next_game_hint: "¡Haz el siguiente en ≤ {seconds}s para mantenerte dentro de la media objetivo!",
    avg_time_play_next_in_attempt: "Jugar siguiente ({current}/{total})",
    avg_time_start_new_attempt: "Empezar nuevo intento",
    avg_time_attempt_lost_title: "Intento fallido",
    avg_time_attempt_lost_hint: "Perdiste un juego — este intento falló (cada juego debe ganarse).",
    avg_time_attempt_slow_title: "Media demasiado alta",
    avg_time_attempt_slow_hint: "Completaste los juegos pero la media quedó por encima del objetivo. Este intento falló.",
    avg_time_attempt_unreachable_title: "Media objetivo inalcanzable",
    avg_time_attempt_unreachable_hint: "Aunque los próximos juegos fueran a 0 segundos, la media quedaría por encima del objetivo. Este intento se dio por perdido.",
    avg_time_attempts_left_hint: "Aún te quedan {left} intento{plural}.",
    avg_time_no_attempts_left: "Sin intentos disponibles — eliminatoria fallida.",
    attempts_remaining_this_elim: "Intentos restantes en esta eliminatoria:",
    did_not_pass: "NO PASASTE",
    failed_attempt: "Intento fallido",
    each_new_attempt_costs: "Cada nuevo intento consume 1 de tus intentos disponibles.",
    knockout_label: "Eliminatoria",
    passed_uppercase: "¡PASASTE!",
    knockout_now_complete: "Esta eliminatoria está ahora completa.",
    elim_info_title: "Datos del alumno",
    elim_info_student: "Alumno",
    elim_info_school: "Escuela",
    elim_info_game: "Juego",
    elim_info_level: "Categoría / Nivel",
    avatar_customize: "Personaliza tu avatar",
    random: "Aleatorio",
    male: "Masculino",
    female: "Femenino",
    bg_color: "Color de fondo",
    save_btn: "Guardar",
    ava_hair: "Pelo",
    ava_eyes: "Ojos",
    ava_eyebrows: "Cejas",
    ava_mouth: "Boca",
    ava_glasses: "Gafas",
    ava_clothes: "Ropa",
    ava_skin: "Piel",
    ava_haircolor: "Color pelo",
    ava_clothecolor: "Color ropa",
    ava_beard: "Barba",
    ava_beardcolor: "Color barba",
    vsr_hero_title_left: "VS",
    vsr_hero_title_right: "",
    vsr_hero_desc: "Nuestros robots se clasifican según tres parámetros: velocidad de respuesta, porcentaje de respuestas correctas y fuerza mental. Cada vez que derrotas a un robot, ganas puntos para la clasificación equivalentes al doble de su fuerza mental. ¡Pero cuidado! Si eres derrotado, perderás puntos equivalentes a la mitad de la fuerza mental del robot que te haya vencido.",
    vsr_step_name: "¿Cómo te llamas?",
    train_name_required: "Indica tu nombre para empezar.",
    train_nationality_required: "Elige tu nacionalidad.",
    train_game_required: "Elige un juego.",
    vsr_load_failed: "No se pudo cargar.",
    vsr_pick_robot: "Elige un robot rival.",
    vsr_missing_fields: "Faltan {n} campos: {list}",
    vsh_invite_declined: "Invitación rechazada.",
    vsh_private_code_ready: "Código listo: {code}",
    vsh_name_required: "Indica tu nombre.",
    vsh_invite_sent: "Invitación enviada a {name}",
    vsh_invite_expired: "Sin respuesta — la invitación expiró.",
    vsh_invite_timeout_auto_decline: "Tiempo agotado — invitación rechazada automáticamente.",
    vsh_rematch_waiting: "Esperando a {name} para la revancha…",
    vsh_rematch_unavailable: "{name} no volvió al lobby — sin revancha esta vez.",
    vsh_rematch_offline: "Rival no disponible — revancha cancelada.",
    vsh_rematch_declined: "{name} rechazó la revancha.",
    vsh_rematch_prompt: "¿Revancha?",
    vsh_rematch_prompt_sub: "¡{name} quiere una revancha inmediata!",
    vsh_rematch_accept: "Aceptar Revancha",
    vsh_rematch_decline: "Ahora no",
    vsh_playagain_prompt: "¿Nueva partida?",
    vsh_playagain_prompt_sub: "¡{name} quiere jugar otra vez contigo!",
    vsh_playagain_accept: "Aceptar",
    vsh_playagain_decline: "Ahora no",
    vsh_copied: "¡Copiado!",
    vsh_error_generic: "Error",
    vsh_fill_field_before_room: "Rellena el {field} antes de crear la sala.",
    vsh_fill_missing_fields: "Rellena los campos que faltan: {list}.",
    vsh_field_name: "nombre",
    vsh_field_game: "juego",
    vsh_field_code: "código de 4 dígitos",
    vsh_pick_code: "Indica un código de 4 dígitos.",
    // VS HUMANO — lobby / UI copy (2026-02)
    vsh_connecting: "conectando…",
    vsh_page_intro: "Juega un duelo en tiempo real contra otro humano. Elige tu juego y tu nivel/categoría — solo verás online a quien haya elegido el mismo juego, pero cada uno juega en su propio nivel.",
    vsh_invite_expire_tip: "Tiempo hasta que expire la invitación",
    vsh_step_choose_game: "Elige el juego",
    vsh_step_choose_level: "Elige el nivel",
    vsh_step_who_online: "¿Quién está online?",
    vsh_hint_pick_game_first: "Elige primero un juego",
    vsh_hint_pick_name: "Indica tu nombre",
    vsh_level_or_tier: "Nivel / Categoría",
    vsh_level_label: "Nivel",
    vsh_searching: "Buscando rival…",
    vsh_searching_sub_html: "Aquí aparecerán otros jugadores online que <b>hayan elegido este mismo juego</b>. Cada uno juega en su propio nivel/categoría — el primero en completar SUPERT gana.",
    vsh_challenge: "Desafiar",
    vsh_waiting_short: "Esperando…",
    vsh_private_title: "DUELO PRIVADO",
    vsh_private_host_title: "Crear código (host)",
    vsh_private_generate: "Generar código",
    vsh_private_enter_title: "Introducir código",
    vsh_private_enter_btn: "Entrar",
    vsh_private_hint: "Acuerdas el código con un amigo. El host define el juego y el nivel.",
    vsh_back_home: "← Volver al inicio",
    vsh_invite_title: "¡Invitación de duelo!",
    vsh_invite_sub: "<b>{name}</b> quiere desafiarte.",
    vsh_invite_countdown_prefix: "Decisión automática en",
    vsh_accept: "Aceptar",
    vsh_reject: "Rechazar",
    vsr_step_game: "Elige el juego",
    vsr_step_level: "Elige el nivel",
    vsr_step_robot: "Elige el robot rival",
    vsr_pick_game_first: "Elige primero un juego",
    vsr_loading: "Cargando…",
    vsr_no_games: "No hay juegos disponibles.",
    vsr_no_robots: "Aún no hay robots configurados para este juego. Pídele al administrador que cree uno.",
    vsr_start_duel: "Iniciar duelo",
    back_to_home: "Volver al inicio",
    levels_label: "Niveles",
    tiers_label: "Categorías",
    yes: "Sí",
    no: "No",
    lives_lost_title: "¡Perdiste una vida!",
    lives_used: "Vidas gastadas",
    lives_remaining: "Restantes",
    penalty_applied: "Penalización aplicada",
    continue_btn: "CONTINUAR",
    logout: "Cerrar sesión",
    logout_confirm: "¿Estás seguro de que quieres cerrar sesión?",
    logout_warn_loss: "¡Este partido contará como una derrota!",
    welcome_back: "Hola",
    edit_btn: "Editar",
    rank_competition_title: "Ranking - Competición",
    col_game: "JUEGO",
    col_level: "NIVEL",
    col_level_or_tier: "NIVEL/CATEGORÍA",
    col_name: "NOMBRE",
    col_school: "ESCUELA",
    col_best_time: "MEJOR TIEMPO",
    col_share: "COMPARTIR",
    all_levels: "Todos los niveles",
    all_tiers: "Todas las categorías",
    // ── Eliminatorias landing (ES) ─────────────────────────────────────
    elim_landing_eyebrow: "Eliminatorias SUPERTMATIK",
    elim_landing_title_prefix: "Rumbo a la",
    elim_landing_title_highlight: "Gran Final",
    elim_landing_title_suffix: "!",
    elim_landing_subtitle: "Crea tu cuenta de alumno, supera las eliminatorias de tu juego favorito y gánate un lugar en la Gran Final.",
    elim_landing_how_it_works: "Cómo funciona",
    elim_landing_step_1: "Crea tu cuenta — solo necesitas un usuario, email y contraseña.",
    elim_landing_step_2: "Completa tu perfil con nombre, escuela y nacionalidad.",
    elim_landing_step_3: "Elige una eliminatoria disponible y supera el reto.",
    elim_landing_step_4: "Completa todas las eliminatorias del mismo juego y clasifícate para la Gran Final.",
    elim_landing_important_label: "Importante:",
    elim_landing_important_body: "tu cuenta de Eliminatorias es independiente de las credenciales de competición/entrenamiento. Cada alumno tiene la suya.",
    elim_landing_tab_login: "Entrar",
    elim_landing_tab_register: "Crear cuenta",
    elim_landing_tab_forgot: "Recuperar",
    elim_landing_back_home: "← Volver a la página inicial",
    elim_login_username_label: "Usuario o email",
    elim_login_username_ph: "ej.: ana_silva o ana@escuela.es",
    elim_login_password_ph: "••••••••",
    elim_login_submit: "Entrar",
    elim_login_submitting: "Entrando…",
    elim_reg_username_label: "Usuario*",
    elim_reg_username_ph: "ana_silva",
    elim_reg_email_label: "Email*",
    elim_reg_email_ph: "ana@escuela.es",
    elim_reg_password_label: "Contraseña*",
    elim_reg_password_ph: "6+ caracteres",
    elim_reg_confirm_label: "Confirmar*",
    elim_reg_confirm_ph: "repite la contraseña",
    elim_reg_profile_hint: "Perfil (opcional — puedes rellenar después)",
    elim_reg_name_label: "Nombre completo",
    elim_reg_name_ph: "Ana Silva",
    elim_reg_school_label: "Escuela",
    elim_reg_school_ph: "IES Ejemplo",
    elim_reg_nationality_label: "Nacionalidad",
    elim_reg_submit: "Crear cuenta y entrar",
    elim_reg_submitting: "Creando cuenta…",
    elim_reg_has_account: "¿Ya tienes cuenta?",
    elim_reg_go_login: "Entra aquí",
    elim_forgot_hint: "Indica el email asociado a tu cuenta de Eliminatorias y te enviaremos un enlace para definir una nueva contraseña.",
    elim_forgot_email_label: "Email",
    elim_forgot_submit: "Enviar enlace de recuperación",
    elim_forgot_submitting: "Enviando…",
    elim_forgot_back: "← Volver al login",
    elim_forgot_request_sent: "¡Solicitud enviada!",
    elim_forgot_request_body: "Si el email existe en nuestra base de datos, has recibido un enlace para definir una nueva contraseña (válido durante 1 hora).",
    elim_forgot_test_mode_label: "Modo de prueba (email MOCKED):",
    elim_forgot_test_mode_hint: "usa este enlace para continuar.",
    elim_forgot_open_reset: "Abrir enlace de reset",
    err_fill_all: "Rellena todos los campos.",
    err_login_failed: "No se pudo entrar.",
    err_register_failed: "No se pudo crear la cuenta.",
    err_required_fields: "Usuario, email y contraseña son obligatorios.",
    err_password_too_short: "La contraseña debe tener al menos 6 caracteres.",
    err_passwords_no_match: "Las contraseñas no coinciden.",
    err_forgot_failed: "No se pudo procesar la solicitud.",
    ok_welcome_named: "¡Bienvenido/a, {name}!",
    ok_account_created: "¡Cuenta creada con éxito!",
  },
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    // A `?lang=pt|en|es` query param gives shareable, per-language direct
    // links (e.g. /regulamento?lang=es). It wins over the saved preference.
    try {
      const q = new URLSearchParams(window.location.search).get("lang");
      if (q && ["pt", "en", "es"].includes(q.toLowerCase())) return q.toLowerCase();
    } catch { /* no window / bad URL */ }
    return localStorage.getItem("lang") || "pt";
  });
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);
  // Stable setter — reference never changes, so consumers using only setLang
  // (e.g. the intro splash) don't re-render when `lang` flips.
  const setLang = useCallback((next) => setLangState(next), []);

  // Runtime i18n overrides — MongoDB-backed values that take precedence over
  // the compiled `dict`. Loaded synchronously from localStorage for zero
  // first-paint delay; refreshed from the API on mount so admin edits reach
  // clients within one page navigation.
  const [overrides, setOverrides] = useState(() => {
    try {
      const raw = localStorage.getItem(OVERRIDES_LS_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch { return {}; }
  });
  useEffect(() => {
    let mounted = true;
    api.get("/i18n/overrides").then((res) => {
      if (!mounted) return;
      const data = res.data || {};
      setOverrides(data);
      try { localStorage.setItem(OVERRIDES_LS_KEY, JSON.stringify(data)); } catch { /* quota */ }
    }).catch(() => { /* offline — keep cached */ });
    // Also bootstrap the compiled dictionary into the backend so the admin
    // search UI knows what keys exist. Fire-and-forget; irrelevant to UX.
    api.post("/i18n/bootstrap", { strings: dict }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  // `t` depends only on `lang` and `overrides` — memoize so the reference is
  // stable between renders that don't change either.
  const t = useCallback((key, params = {}) => {
    // Priority: override[lang] > compiled[lang] > override[pt] > compiled[pt] > key
    // Compiled `[lang]` wins over the PT override so a new compiled ES/EN
    // key never gets silently replaced by an admin PT-only override that
    // was left untouched for the other languages.
    const override = overrides?.[key];
    let s = override?.[lang]
         ?? dict[lang]?.[key]
         ?? override?.pt
         ?? dict.pt[key]
         ?? key;
    Object.keys(params).forEach((k) => {
      s = s.replace(`{${k}}`, params[k]);
    });
    return s;
  }, [lang, overrides]);
  // Memoize the context value so its identity only changes when `lang` or
  // overrides change. Without this, every parent render creates a fresh
  // object and forces every useI18n() consumer to re-render.
  const value = useMemo(() => ({ lang, setLang, t, overrides }), [lang, setLang, t, overrides]);
  return (
    <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
